const BOARD_SELECTION_TEXT =
  'The nominees in this category will be evaluated and selected exclusively by the SPEEEX Board Members.'

// Current live survey categories. These are submitted in the currentSurveyAnswers payload.
export const currentSurveyCategories = [
  {
    id: 'employee_of_year',
    name: 'Employee of the Year Award',
    description:
      'Celebrating the individuals who consistently go above and beyond, embody SPEEEX values, and make a lasting impact through their dedication, professionalism, and outstanding performance throughout the year.',
    enabled: false,
    boardSelectionText: BOARD_SELECTION_TEXT,
    nominees: [
      {
        name: 'Besim Derguti',
        image:
          'https://cms-files.speeex.com/besim%20derguti%201-1780924852003.jpg?Expires=4934524853&Key-Pair-Id=KRA0L08OBFIGO&Signature=dTGhfpDv84-yTUbV1mBEOfc9cmrjtk9P5Z-foZ0c7v1pxmy554pdXDvPtVz1~pOG52~iR3Nk-Og-h4IlhAoIlzpZytpViI3mS~0aZKTiaLbgh-l63YNA9v4E6jvZnxlM4vghpiq7G0TOVkpHZ6VyXj2qqpUIgHMEMfViz08YrFxavspISQDQd-TlqCp~lF0F5zMQjNnHlMJU33Kl94lkPSGMDqFaZ~dp59JA7HShZWFiGH2fMDFEN4df2~WxERoUOa~6kufcYkdcxunWkTduqBew~0pQgABV~~ddwON7UCZuGoWozNdX5~tJ3miHWeZ-q8SvUAd-7LjbuYuZwvOZqQ__'
      },
      {
        name: 'Florim Krasniqi',
        image:
          'https://cms-files.speeex.com/Florim%20Krasniqi%201-1780925019109.jpg?Expires=4934525020&Key-Pair-Id=KRA0L08OBFIGO&Signature=epuBUbpC4o8YS7mqSR-axCeEhfBt3vvbwQkCVhGg3SE3TFpAUr8P4UtFeByFuQEpmhz-gbOYRmntvfT2Z0mJwzG2gyAf2af~b7NQmTIBmWT2cpI0Uthb32RZeF4WTxIbw81-BIi7S5JzKZXbAuSF8SB3oQIr7Cijwa6oDNy7LnAVxiZ2b3-HywHvnoephXqlG30M3fXMVBpGpjWI~ndDKq70is5VVCUJA5ikq4I7C98pQG1IkzY~ornEyqq585Zmfyh0yo25ukzcCPyCNHDPufZ1GosqByHMZYl7tFPzvBgVyRUIqhXASWQIwcNk9i1oxR-D487EV7LHRfgIq2HZJA__'
      },
      {
        name: 'Fatlume Gashi',
        image:
          'https://cms-files.speeex.com/fatlume%20gashi%201-1780924935922.jpg?Expires=4934524937&Key-Pair-Id=KRA0L08OBFIGO&Signature=rMiCSuJ-YN5F~9rbei-jOgdVbgLHNU0meZuG46T-BuZvGtLdh36HmZi1zKfGzyif0yPAMHfwtdNufTcI0MTwkd40NS3IUKr1TVHtnoX6tFL8JDeJaIcQ175sZs1SZj94CzlsOdQznT0jrzmJKlWARaoTLYk8a3buSqZa9L~5pNKLRBPOBloZWZ2bAX6ezs9dvw2D5bTdkX6KAgXXuelsoCrx1P~fa9aEn~4RJfPPKxOnug-xodjTzlDkHoPrAnNFyMq2J24ifmy~pBeaLoYISyJyMC7C3m95d34gkH8S2Vxu6dAlb9tKhKbzWS9G9~Am~XkTL3Y6QnRp5fb0t1WgYw__'
      },
      {
        name: 'Uke Kastrati',
        image:
          'https://cms-files.speeex.com/Uke%20kastrati%201-1780925134758.jpg?Expires=4934525135&Key-Pair-Id=KRA0L08OBFIGO&Signature=n6CfH8kMsccunCn~xoRmDROR9T2g8siM4zTEqxl~NUPztzuPEY48XAVR8WC5bKNxyI2UkCRToB6EdxD1CHJHPR184s9bg4sd8PaBGy3ybklTtNlcBU8fnKYFjkpltvEWtvN2pFNMwX3ENp4-fyNCcGC92W4ngvZ6AyC1NknEcRXg61TM-~t1O2NLk0r4gsCy~GSXB2RdEXhK5C5JKDW-JqPBYKw3Sm8Tf9Qo-CdMKTgVvTKftPgYuTO07DnBnhOYVj5ifdBN4qdHN~-NjLuc8HQ6mY5wUiFqnUpWZcIDZS9FRkKf5oxpNAhj0w9t57q4OgbcvCkOUoB1fCO9kSYocQ__'
      },
      {
        name: 'Rafet Hasani',
        image:
          'https://cms-files.speeex.com/rafet%20hasani%201-1780925096222.jpg?Expires=4934525097&Key-Pair-Id=KRA0L08OBFIGO&Signature=XjAZBUUFCJAuZ3tyrxH3z5YU-SytHyzJLQX~Wg0K39b8QAe8oMzhN7EFcC5vWLmmuB9g5j0jQEv23QKSZg3bOcPJIWe8VEuwzhwSjP858uwv6-jfRxh0Gy7MHFHRT38-HrGwiY1dJb8tHIlMFLtT9-7Cly0UfzLNGtqb1zqLy-BQvU1ommjv0dt0-v60tfInFz8J-M~y8tGd2p8ZKsqLeIMht5ERwu-VUlcWN2n02Z~do~KjD0xI0pv39yIQSJWUZ8Fs1-PRxSG7TBWKfe6LqNzE9VWuC5QOLTl8tH1gPkwSJ8lf-wE2p1biPEmaCCj5JDEbjxwZc~wpfFEsfaqrTQ__'
      }
    ]
  },

  {
    id: 'customer_service',
    name: 'Customer Service Champion Award',
    description:
      'Recognizing individuals who consistently deliver exceptional customer experiences through professionalism, empathy, problem-solving, and a genuine commitment to customer satisfaction.',
    enabled: false,
    boardSelectionText: BOARD_SELECTION_TEXT,
    nominees: [
      {
        name: 'Ahmet Hyseni',
        image:
          'https://cms-files.speeex.com/ahmet%20hyseni%201-1780924642050.jpg?Expires=4934524643&Key-Pair-Id=KRA0L08OBFIGO&Signature=McivN9hNQbDCxxGh4Nk50SOjcPmRWx9AKOCfGllbnW~ZCrjr7IN5huWygT6cV52WqI38pSZIfP1TNuXNlhY9jtf6LY-9rqOq2gDhzdXF0XuSvnUuDyLc87jqjnrJ8gw3QtI7UwxSm7cShsB9ex0SLKAKPlPDMNAlc5jcFI-EMM8vGqg7jlIJYPkKfIcBBO8psY7GmHGtde~FbXHavzxhiOg7G4Kyqvw5INgjcK6msdkvfF49Mkn-nh1DVwYttOL98x5IMiMRgduXkNKn8jNbVfD7Pv1cXJIQafSuqLZy~2vap2rl7EgYvKkCMoBN8I0-HHXkw7~BNmaDq2q~3gRyxg__'
      },
      {
        name: 'Fitore Hasani',
        image:
          'https://cms-files.speeex.com/fitore%20hasani%201-1780924988328.jpg?Expires=4934524989&Key-Pair-Id=KRA0L08OBFIGO&Signature=K4TGxtw3uCBv5ROu75I5tBSa8jzpXeWSMM6MLrFPAOPc-X0TIweAZLbTdF1GUK2YdIbGDsdA-KA8AL0FJzwjVUTAhxBv4irgZk5eBfsrzsTeuFoCH1sby1OgAMInEw6NGYLHo-PVA4oK0h3OPN0XULkg9TibzzsnU~giTp52cIYFmjCPXOgcEqEOteQLamB8b8THZl2bobPcCl8SOhIJ8~0A6NJQ~6O3NGpBd0n9ybhrtJ2-3zxO-oH~0sUVy55ZdwfkSTAPj74Ty1VrGPOfJhHZLmI8TK1~HcuycYjgcsSWkIRTRRNjVTeQmnQGq3Sc3ZGVZdeps5xYx4CkHoJ12A__'
      },
      {
        name: 'Bajram Kalludra',
        image:
          'https://cms-files.speeex.com/Bajram%20Kalludra%201-1780924828988.jpg?Expires=4934524830&Key-Pair-Id=KRA0L08OBFIGO&Signature=N6gbzJEBdu3QJcZhTLb6A6uDug0AEsSUpkMiA1x0y66MXJl45SVhN-hHwJ54gXkLPmWTAmANr0Za0VUL7gl00Rz0JkSM5NcSW0J3upqRafEvUKesyy7WpH~-iHymQmnJ8zo2Mqa3QX9Lj~o8q~iwupJcD73A37kS1vOpN~FBCPdtrt84J0~5Ql1Z~ssHhpfRwJ2~EFLPoFDucjimz~HQS6Z3m6hRP-ob3FQKoenux6fPJYELLI8cMtu6UUuZE3ABt2wkgOfSzTKiWRf0P18PNxzPq0OCG3G5lJQe0b~wSgO7qird9vtMcWaeoHuGUg6ANPabwueCbWRnDRiWR0n5EQ__'
      },
      {
        name: 'Ridon Restelica',
        image:
          'https://cms-files.speeex.com/Redon%20Restelica%201-1780925121974.jpg?Expires=4934525123&Key-Pair-Id=KRA0L08OBFIGO&Signature=UOOVeMi5s2lUFnd9g-ABqoDZQjtvU2Z9z-KHpyAdM6SycPUvF6B94ycLlS26OL271sDKjxEgcKGW-wAnkIMgDq2taVa4pcOmQrarh6uTKn-CmlXPBpFdI6s7bR~kJswmZLriXXO3Wthc8DMyagRePE1X~EgNqnn-t6u-ebf3a08wkZaRor3cqBLPn05~6ycq-0jmprcJk3vlNVnPoLULTW90KrQznUg7QGS~dMt9DknuHrhtz~RhfY7zT1DaqHCzC57a6puZfY3WRpObpUd0pktd~tHewGZKavvW4kVUN5GOeFT4VF2INvGoXuEbEYQck8Fkk49e90lwKcI~NQGu1Q__'
      },
      {
        name: 'Abetare Vllassaliu',
        image:
          'https://cms-files.speeex.com/Abetare%20Vllasaliu%201-1780924569767.jpg?Expires=4934524571&Key-Pair-Id=KRA0L08OBFIGO&Signature=yJraiNNmbbimaqtKTwgzH8rTBLTvz4APvv3HtQJiqaVzSl3EW4GtrfVlfSM0kPgeiGS2uraC2560cKGZEvhC02s8tbhllqo68G-a0LpznwS5noZkZcdriL3fH2WvUzseXGw19oF9I24pBD8LCQ9deTBYLZn2yCZ58JXieveml65DzA95xV209516pEeKpf~tSe9j6G6D~WXYu5Op~-f6Mh1ijl5Zow~8usrmLqaK9pc8eX-nizXMFRsm~~Zfb-nT~5M-WfHL0fXbMKP8rVs~D8COA0O2sIOww~Ll8cc2DG8rCb1yp0xgEt0jcRhGYKK2N9u852MWcPmZgawxiqmJiw__'
      }
    ]
  },
  {
    id: 'team_player',
    name: 'Team Player Award',
    description:
      'Recognizing colleagues who foster collaboration, support their teammates, and contribute to a positive and inclusive work environment. Their willingness to help others strengthens the entire team.',
    enabled: true,
    nominees: [
      {
        name: 'Ariana Krasniqi',
        image:
          'https://cms-files.speeex.com/ariana%20krasniqi%201-1780924803552.jpg?Expires=4934524805&Key-Pair-Id=KRA0L08OBFIGO&Signature=0uo55sDR-Ku~TOia8XOfYPuXG1FG49K64s7WY4zByXAUD0cyfcuhGVkeKb33hG0KL5vY8y9Ko68dL8y~-H9laixgofgYWlrRiIs1LpE-8PGF38e6yi5U-hB6Z~A1T3YPXehEw-S0s~y78VlP81oibkkBjcoiT4akDN6wvqLgUa3TLeQ~UCqngC7J43bgNItUSoEJkinH2Fy66BpQNkOONnFkZY3iIzxcZ82L-AJwtOaav0p52rj7U~-Dwjp2GaOESAsKHxUBpULtDcptodHUbt8KHrkVoVZHqLNScJNZbY~S52x4M7N3i713~-j3uCEPoyU8cVVEEAFYog9O1bm~aA__'
      },
      {
        name: 'Adelina Preniqi',
        image:
          'https://cms-files.speeex.com/adelina%20preniqi%201-1780924584201.jpg?Expires=4934524585&Key-Pair-Id=KRA0L08OBFIGO&Signature=HrxrqFx7YroXMz4DEOb5TD4ckTZMR-LB-HQ-hX2jGOz~YvLovn3YHrZzJbNEXX9VERQuiZpMlrVfpb0RS7OUz-gTEY~bZa0iiLerGL7jqSnnRfxcLJRCCtZPyrTMPe~H~aie69nc6qxGKwCNbD0BSRSWnNCdocQdWYNoN5~H8nxtzrlMPDJ~XcgKShCAvY~ILAkkhutTeijg3scTWEiv8813pF44b6hJZ2e2WVJ4Sm0YX5yiSXZ-6pxawiPPmIu32Sq8gi3s0JqfQ1fue-EQ3KDqZqK7boj5tB8Gxg6EZbtlDa2Zh3itZ4g4SeSkBwrMlYLR25nBHPt-Sy15WSfARw__'
      }
    ]
  },
  {
    id: 'rising_star',
    name: 'Rising Star Award',
    description:
      'Recognizing emerging talent who have shown exceptional growth, initiative, and potential. These individuals have made a remarkable impression and are on a path toward even greater achievements.',
    enabled: true,
    nominees: [
      {
        name: 'Aferdita Rashiti',
        image:
          'https://cms-files.speeex.com/aferdita%20rashiti%201-1780924626801.jpg?Expires=4934524628&Key-Pair-Id=KRA0L08OBFIGO&Signature=F9K9BMhJJpRDP7r4mjL48meBSPzemRH16DNmUcpSb04Z2TPwYHaVip0M9bnEXJHnxdRbtgey4T8sK49x3eQ~DKAjMe6sfxJZ~MJruVK1YjDvGG3QCtCjgdl~BAP7dXPBG6p4Olz8vf0kgZrZwS1JxI~b5tayJRMulFNDu87lMx-nKZwlAXVZjbqTmOVUfspDexoJl58UgdMXg0TK3Ro1bYyDj1y6QKHVr9beowfcrpjxzUC9BfqA60g1zbodO7Zfwvlkd5KLpF7lq2vOGUCGPEeTUgCysldOc9p50ZJizgodFh0F0miPyeAC~~I3bSmJFzXz9qqFcUi3IRVolm2ruA__'
      },
      {
        name: 'Freskim Mjeku',
        image:
          'https://cms-files.speeex.com/Freskim%20Mjeku%201-1780925035425.jpg?Expires=4934525036&Key-Pair-Id=KRA0L08OBFIGO&Signature=iVxM13v-ItbyjpwnQzrzf~DMZ63Sa8HgOxaVAK889EwB4FJvif9AZu8CIVouRfAJMcUVV6AGehflAQXdvw0EcbPFBdc4YxJH~C4HppW87X6JQIZUbrVlH-sSb6h3nKj0XHGbjNnNK~qlXpWXc2bSO9jfnqmOQQ9iiaxsUXKOMZA42bZJCaL7PDyD1G0a8vTlXDaBTX90il3LgW8B-LqxtCi3O9JGzALlGJslZRkCTBeyMK13Ub3n7qarKnsNJQTEBwtCDe~4ulXXV-02jpNqCyoLXAfCi1deDGYQU1yP2vn4WZwrynEHQIt~F9FDrK5mh-67IyWg6t4nlzeeulNMGA__'
      }
    ]
  },
  {
    id: 'career_achievement',
    name: 'Career Achievement Award',
    description:
      'Celebrating individuals whose long-term dedication, expertise, and contributions have helped shape the success and culture of SPEEEX. Their journey serves as an inspiration to others.',
    enabled: false,
    boardSelectionText: BOARD_SELECTION_TEXT,
    nominees: [
      {
        name: 'Pranvera Cecelia',
        image:
          'https://cms-files.speeex.com/Pranvera%20Cecelia%201-1780925082242.jpg?Expires=4934525083&Key-Pair-Id=KRA0L08OBFIGO&Signature=Iqj~219f1A30yWwiVpbZgJMv~znmAI1orOfQnrhgRq2SRDVKrHYEwbA5CK0gdrSAWIJSVn33CGBBttpeDLSRAJScZ~0KlwZhmWrW2DmGACcRDzgc7xk5WVoK7BV~k8~-K8ErpSE4bG7T6ZH9U6lTJEIypJ5ArFzpVudKSzErnyCvM8R1fD4Ilkdzuh0LV7ycw05lg5Ky~c7huJc3acEHp~RHKMkxGUGehpT5wIGZISnaQrk4wE1PYWcINsi59UcaTUzOkpns4NWDWKkUC47BnJ7R2J8iaEzxGewD7logCj3ha48BgqV-15XCv0Li9VCW~BPdykl5UEA6v95cesowVw__'
      },
      {
        name: 'Erjon Kundja',
        image:
          'https://cms-files.speeex.com/erjon%20kundja%201-1780924899887.jpg?Expires=4934524901&Key-Pair-Id=KRA0L08OBFIGO&Signature=w9VZAqc~OWwXcKPzh~PE7~l2kklrwtd5xsfJ7~-VHHkWa~VY8L4P5BaNXbjhB~NeGncl00XXA4Yvuv2K~tT4~FO8FrN8KSYhmO--VV-elvTHjCSDxZQJDZm48oAbY1RZZAKjvz5iR2jtXJsjkIlDI5vbFG6B7LpfQzKhfCiV4ohqeaOTj15HI6GHPRNkxfe44TaXD18B3XMoc4Q~nvevcA8HOl~FeVrJZDL9S3Xqs-QARa0wVRp2uB~hs~263mz6UNtF0dJf8v-IyL6UCzY1mgRLDlftCT6PhAPTYq67Ki765nhQOa5eu8nih~-YdeWhXIAaT6yjan4rnFvAQgOj2Q__'
      },
      {
        name: 'Ramadan Gashi',
        image:
          'https://cms-files.speeex.com/ramadan%20gashi%201-1780925111140.jpg?Expires=4934525112&Key-Pair-Id=KRA0L08OBFIGO&Signature=Ey~sGvmzzDnzTVutpty~zdA9rdnyiTMKO5VxKkpX2V-e~AgWOzFA8k6j9EmBKYvBDyQwR60MdtQnF9EbWx71PCb0gHa0F~IlNBLo9B08olp9vOhUoP-EwZ6e1ONaHqHeeaD-GyZ5~ax973rDGP4VrJRhaCi1WgOdEuGGn1OFSRCHTpHRo6rc~1XO1UIaVrF0UNHLY87olWyVqHyJO6HU8Go2ltmsqPt8Lc9UFkA-ejBL6aA5VteOtHNUh66DQzgU4~pN3xG0wuIZc09w1JrWTj-MxHYL6g8Nht45omTKvcvWDB6Z6fXUlvtBr0SVmZiblKXTnAyDbH-3Q6krGMubyw__'
      }
    ]
  },
  {
    id: 'innovation',
    name: 'Innovation Excellence Award',
    description:
      'Honoring those who challenge the status quo, bring forward creative ideas, and contribute innovative solutions that drive improvement, efficiency, and positive change across the organization.',
    enabled: false,
    boardSelectionText: BOARD_SELECTION_TEXT,
    nominees: [
      {
        name: 'Ardi Qestaj',
        image:
          'https://cms-files.speeex.com/Ardi%20Qestaj%201-1780924741720.jpg?Expires=4934524744&Key-Pair-Id=KRA0L08OBFIGO&Signature=Ugt5BgtkI8Eyhg8SV5lXWf46k5MfOoyuCuNQw3WbcFUkmtxUO~effQufEmd5KOqahr5XU3Hatb1V2KKxuemaQ2SF60x~84k8LJZU309ShqDGfdixLjlNvYVG34APBJgkT7EgGe~gMJ3EWFWa1mDBv5ll2NpnkHwunkPeOg~J6LQA11BV2jvx6w7Co37WoLzhAQ5k5OuDAZiFyJjsYLWo710pzWmTwo4PzqbqDzej4j5cc~gD2MOamE9TBVM0YZWuglRtuFMneUIqZCvohG5J63St8cQSovtBkKJDwMC7aDM3f~PKWP~hWWpTyNwO55Wg~8OjxaSU4C-jfbt3Gs0AAw__'
      },
      {
        name: 'Adonis Rexha',
        image:
          'https://cms-files.speeex.com/Adonis%20Rexha%201-1780924603607.jpg?Expires=4934524605&Key-Pair-Id=KRA0L08OBFIGO&Signature=lxFshk24sFfcQohtbVStQhhjbpAv8p-1sDzvRG0-8iboXBSlX1Y1v5NvveCIAEoTbTdgg-5KXqeF6kRTnJ4PV0-lWH52UMJTiWPPm5Z6QOnmtlfJARk~vR9wq8wcBYScQuObl~7QxMjgadFt1Th5g7HRxQIqayKqKVaTMTlPxWguzRUrc-QU9yt5j8qBEFVrwOdFxQ2Mb-higud4F6frRtYh7t3DyaH8XyyX~J7nwIzzqQwVQo9LbX6VXgrfBuCpkRt5lr6SBlUVXLODXGt8WIzz8TDZFry3kjDztNIzRmrM6IgrMdYksQdFUVCgnvY4gZq3MT0sSTgIjVBc8j5neA__'
      },
      {
        name: 'Lejla Bahtiri',
        image:
          'https://cms-files.speeex.com/Lejla%20Bahtiri%201-1780925061955.jpg?Expires=4934525063&Key-Pair-Id=KRA0L08OBFIGO&Signature=H5quj44G4MIcAspa0H55dV1bgvj5Bk3-9MFmZSzgD5TyWx-4g7kyb8T8gDdmgdIK54GT~wvf~Z6iNpdS9ftSplG6-NOpyTMXkIVFs8qa5re5zW5R83OC7gfIMaq4QwDlVb1fIjnZSseMIRBLwX-nP5dZtSh55pIeCKdTI7h50D6Zcdqv-L25kbcWYAdqEWMn6acRagFIKE6mgN6im9IhLWcoMCtUIzkpFJpaNlIAh8BhPB~Sn3rjiZ2KGQRAgkLG1qEWcsRtGcaXIiie5yoS-DGvJHR3VcfnP9VueXILyr3STzCYxGjcZZIsQ~FSO0Vkasomh6-igP9MOnRcaSy6QQ__'
      },
      {
        name: 'Ardian Kurtolli',
        image:
          'https://cms-files.speeex.com/ardian%20kurtolli%201-1780924762170.jpg?Expires=4934524763&Key-Pair-Id=KRA0L08OBFIGO&Signature=SJObaFnFiBWvsps7iurlBIXEiFO28zwSuVAXLjBIzapd6F7yOd-7htglm1Ems3v3p2AJeRzsxjwxjDnkgjJ84mjdZm8ZGvDHW4sWjxngADuhbLTbGUnNiV97wsScXtxz~Rzl2Z7AvWyNtCyx3R7SVOG6hlD0uwalrWaOG5CRQ-OiBfznSwK7rTbvNONQOQysNAOLG6J1Z8Jloqr~dUg6kEsa5p0haXUtXndmmfZlyeFAYdRXwXsnUSADATOceawkv6bKxnxlEedXVWetnhNKN2yA6YKZfsfziLpxP-6zVTowgqrNmHbsKjzvRMUnMJLBKCef8mWMqbDBEwFS9jfK7A__'
      }
    ]
  },
  {
    id: 'leadership',
    name: 'Leadership Excellence Award',
    description:
      'Honoring leaders who inspire, empower, and guide others with integrity, vision, and commitment. These individuals lead by example and create an environment where people can thrive.',
    enabled: true,
    nominees: [
      {
        name: 'Drilon Dobra',
        image:
          'https://cms-files.speeex.com/Drilon%20Dobra%201-1780924869874.jpg?Expires=4934524871&Key-Pair-Id=KRA0L08OBFIGO&Signature=Cq5Ut7NEabuzc2vhdM4MYmY0CbWMO5W5lrTGzlVKEsgk5ULy6fu7wAnZhia8HbG4ZtmRCursbOm0Zt7f4xb0pvPKhywD5TqdFcmWSaEvpVbAGBOIdImptB4ya8CaIw4VtpB~UFwdbPNGKZCUqylIxJvQZRezRNXx5MOcN5CF~KCE5quLm4iUmTFC9i-1Ce-CgRIuxea3yLQuRCeuH2a15iUTqEL~xfU8b47HOv8rJk4XEprHAFS91-6JzSAYjneFwUNyBvgUlxwaTYLGZNGNdEZDm0mb~-9OIXvoV31HA7nnGu1VkyreeNK~DvIihyEKWzWEYbqQwWNadF7ealQIew__'
      },
      {
        name: 'Altin Muli',
        image:
          'https://cms-files.speeex.com/Altin%20Muli%201-1780924660834.jpg?Expires=4934524662&Key-Pair-Id=KRA0L08OBFIGO&Signature=RegAq0bZQepnjxwR0wABIJRBkspeRPoyIF4MoE7XgV7YA~TEwgiXGM2z0K1l9Qf47c9K0ZaQzAu81HloZXzZpJc0XL0UA4gLdqruGSislPDgYIfTBIdBgdaPt0NrvP5RxP9chsmzUBM1QYjQXgMoEdL32fXktnXhpcYUFkfuoFLbkigmNxNsSqSJ0mZLIeXpuOWTfnqNKRF2sKTpOWAjus8DPTtbfa~RPAQ0Kr3KUmt3HMTDyvAlcHmZ9WZ2zihyp6f7-Qj16H2uvu4MXBAkAwjFaM7Adhf2DZl2KpmkA4heoJoSk2~gxRXn3ZSRV9xgFXtwHILheOXXaoxeYHr1AA__'
      },
      {
        name: 'Fitim Kurti',
        image:
          'https://cms-files.speeex.com/Fitim%20kurti%201-1780924968754.jpg?Expires=4934524970&Key-Pair-Id=KRA0L08OBFIGO&Signature=e0E-J04sfOL964mTT0xIjdZsXQ28w6jr0Qh2getTPcZayywsH2PwtG5y27rgzLa7UUd655~hqrIn16m5w7oYV2bAuYnE035~XnoMrJ4ek5RvrywCn8I1YuzXPASsES-esLv0k~CbIF6eVj021o2aid28hV-eZZddXcDrSLceYrzG9PaO~~BO8A9NgbniQ2p66VI7x6Km0mXtCEeWxmtEQEspw2kc6i~SK~Zdp~6R~5hb5mdAkiiWpYUYG8RAN91pDQ6QzQKnujDMncf5nWLv2OFpfQsm0vJetuR-w9fBfviURgzDVdaOGoCszhUnbgjWXPw-Ku17emeLTCCs4m6xtA__'
      }
    ]
  },
  {
    id: 'mentorship',
    name: 'Mentorship Award',
    description:
      'Celebrating those who invest in the growth and development of others by sharing knowledge, offering guidance, and helping colleagues reach their full potential.',
    enabled: true,
    nominees: [
      {
        name: 'Arta Buxhovi',
        image:
          'https://cms-files.speeex.com/Arta%20Buxhovi%201-1780926167959.jpg?Expires=4934526169&Key-Pair-Id=KRA0L08OBFIGO&Signature=TIuOdGrnEVBhJPjru-5JpjhYEVC8D0p2obho0VTp5iRQpepaOU0~s61ryj5XbHGu-KL7V4N7~LWixmK~nDD5XnxCmnM1sNebG9BmWHfWnfAUqps8Sqtm9ZaPRlMRcbMrck2XD9agwKzKHnXIDGIAT1L80OMDOhQv7VjPciAmlVY2RRQvqvLtNsyMQC0h~evPSurevQIj18iTiaYtvV5aJw02LLWUugGsxLh-7yWGrGMH4sucpw7sVqLLHU0Zc~HFQ23ORX~NdHLDfzqaUeCoBYy1Mz83O1iOhHiWmR0gctDpf4eI8ve4O8liBfs6AjRUdmkdGuaKzTKshUjX-oz1JA__'
      },
      {
        name: 'Ilir Ferizaj',
        image:
          'https://cms-files.speeex.com/Ilir%20Ferizaj%201-1780925048723.jpg?Expires=4934525050&Key-Pair-Id=KRA0L08OBFIGO&Signature=KBYfQgKzf3DQOuwxqxOMzPhvCtBlJmM0Uylj104XJ0ORdgnSACeccF9DZNDGFl5ryHiy4wfZUl54ehVq~sMBiMKLcySSuG84WhQk4-ECAt2eDr4itpxBgKPw0tYp33TSyCJDF8qx2gsEAfi72GSfU5PAKe1t6L6Fmet2uqw0wVa3KZ-oVIuvynmM-FUy6y2JwOkB~plzQaC83qtW1G-a8vXQUO6BwOoYZbY16dRJHWRUan~uX1T~RCAAgtYo0FVsS1mZJ-gylbhIg86Jz79TuG8-n2CpgWpUy-j7X0OM2iYa2YsMO67k8UGEs~BZ16ymC4vkvXTiFs3NSR5PLCBrCQ__'
      },
      {
        name: 'Driton Berisha',
        image:
          'https://cms-files.speeex.com/Driton%20Berisha%201-1780926189395.jpg?Expires=4934526190&Key-Pair-Id=KRA0L08OBFIGO&Signature=D1rxFShtR0e9woUtu0GlBDz~gigLOWvN3YGiWY308ohXmcUT55LR8oSxaZMIGPO2pWaHU0sw0HbesEVapFsJ5udJ79GyAgjv6RZ38UrNsGIM-Y7FuGJzTXpsBYsI6NEvM8Wx5rKZb6TKBl-3GuPKBHzVYBZEq8QRbReaMhgOdFgSwYpE2-YPsC-zfk1V~hFg4arMuybdiUQQEJNEYFSayRtZTU~kvxmT~L9jT1dQJwgq6ScbJN~BB92WoxhBmjy35nIxMVGV~lgTNHfkK3iduq4mr~XKdNrg8sUATcfZFAFCJibCrgz5sr-6UJE2cjUG4ccsMcBmlinLgwvVrDYuCw__'
      },
      {
        name: 'Saranda Maliqi',
        image:
          'https://cms-files.speeex.com/Saranda%20Maliqi%201-1780926203794.jpg?Expires=4934526205&Key-Pair-Id=KRA0L08OBFIGO&Signature=0lMjuhZ3RIKAZlfodD1h3tox15bg0YMMUoQE52i6QKaZP~OFXamp4sbpgEOrDvLu~FY9OAxgDHkujqZzF3n1BLBScFDyjDjG0DmtubShRBVRhHai7X4EsxxnL0~kp6IIyWCJyGQYFe0LSuTEH1txLesSUS~xaNhhJ8LbndPJlIfZfnrrmGhOfEW3C4PEYCQaPCrKp6LDkvLOTUtTjjEq8WOKrt7hE1ZMRHJI0Vn8DRiMLfxlecxPTB6z3TsSD0EcorCPBLS4c3YRis-V-fnwfbgebRdiWhbelK~8RDdTP9xZqAAV1PcX0CA7r5GEFBAhCZ-sB4L-VaXvzBSzSkSqRQ__'
      }
    ]
  }
]

export const surveyCategories2025 = currentSurveyCategories

// Legacy next-festival nomination categories shown to limited users during the 2025 survey.
export const nextFestivalNominationCategories = [
  {
    id: 'employee_of_year_2026',
    name: 'Employee of the Year Award',
    description:
      'For the employee who consistently goes above and beyond his duties, demonstrates exceptional dedication, and serves as an outstanding role model for colleagues.',
    enabled: false,
    boardSelectionText: BOARD_SELECTION_TEXT
  },
  {
    id: 'customer_service_2026',
    name: 'Customer Service Champion Award',
    description:
      'For the employee who consistently delivers exceptional customer service, exceeding expectations and creating positive experiences for clients or customers.',
    enabled: false,
    boardSelectionText: BOARD_SELECTION_TEXT
  },
  {
    id: 'team_player_2026',
    name: 'Team Player Award',
    description:
      'For the employee who actively collaborates with others, fosters a positive team spirit, and contributes to a cooperative and supportive work environment.',
    enabled: true,
    isDropdown: true,
    accessToChoose: [
      '66f55461a65a7f26c0384c29',
      '5dd3f73a245dd830d3abb134',
      '68b9315c87c8c877d04d3dbd',
      '68b93328a5ebeaf085fe2f90',
      '68b9307887c8c877d04d3d13',
      '68b960091e7a3433220fc748',
      '68b92fc687c8c877d04d3cad',
      '68ba85244d3638cb4021e4f5',
      '68b6bd84f8ad56d30d78a4ea',
      '5d9ef7db6e558970c974fe12',
      '68b6e245b54aefba203ce37f',
      '68b6a39a08e3a5827154fc84',
      '68b5643593886cb0ceca3637',
      '68b020c753f7f0e0d9cbdcce',
      '68b580550fc7968758645d33',
      '623987f28fa9f4371ef746ab',
      '68b584aacf3367f92a6ff628',
      '68b5699795ac2b53a7a566ef',
      '68b5563578ef310db3cdfb52',
      '68b551d7bd5d1a26589196ca',
      '68b56e08a4f207f1660859ec',
      '68b55b61bff7827ce08882c5',
      '68b558807ed87a4cbf1c6281',
      '68b54ec77ed87a4cbf1c607d',
      '68b022c853f7f0e0d9cbde10',
      '68b5622975f109e10ef4f757',
      '68b197ad0fb86e504a4846fc',
      '616d7dd364959e3f7faf799c',
      '68ad9e900fd26cac5f01b841',
      '67e6bc3d56012d7fc7730f94',
      '67583fe69277c330ff053cf4',
      '68b0450d4adf78c6d6d4bc45',
      '68b045ac4adf78c6d6d4bca2',
      '68aed2664e3272cee950dba3',
      '68b59fb4fb2a3a13dd4da92c',
      '63f7712773303f9006733c2e',
      '68a997b5256d5c001bc63350',
      '68ac29dcf80b91f77755a8da',
      '670d1e9ac094ed2809449695',
      '68a5df08f76399c4e77efd3f',
      '68ac4951420a3d96ac419fa9',
      '68ac4706420a3d96ac419efb',
      '68a5a5a59de0001d612c422e',
      '68a57d536ae4a90d857c514e',
      '68a5a05a583934d60b8abad5',
      '5d9dabadf72a746e59a90380',
      '68a5a87b695c58c22bcc5886',
      '68a5a1a3583934d60b8abb3a',
      '68a43369907ce0b303769b6e',
      '68a33e0645ad6257fffc6dce',
      '68a43514907ce0b303769c29',
      '68a436488b8f6cba0a5a7bb8',
      '68a433f3907ce0b303769bcd',
      '689f18b30cfa17025b331f90',
      '689f41f907cd810014fa6fa8',
      '689f3f0b340e13bf1cef1fcd',
      '689dfdc6c9976abbfcd8eec7',
      '689f43d59fee90072464a786',
      '689f40229e2563d80f71fd36',
      '668bb1cd75d487b466cd7166',
      '6895b8957b41318dae276191',
      '6179a979877daa1294945ec9',
      '68946854843620be79db54f3',
      '68931938b08950b41bfded2a',
      '68936bcfde57c139351bac92',
      '68936cd60d0d0c5624b1419f',
      '5d9de287f72a746e59a903d9',
      '6894b23ad994df6abc767b32',
      '6894b94da35b5e18d6942902',
      '6891bcc839fd96c055a5ddcb',
      '689342dc49eb6b704da7f794',
      '688ccd87d22002d7163651fb',
      '689216490483550014165429',
      '688b6e07777c6b0013b6cff0',
      '688c845838b9ef43ca56d7f1',
      '688ccd1e0b1cd0add08c855b',
      '688cb9677b5afc1ecd388a29',
      '688b702831329fcea473a09b',
      '688b6c167fd583b897fc0ca6',
      '688cb8977b5afc1ecd3889df',
      '6888dd005e3d82f9c13dbc1b',
      '688a1c781729a600145909a0',
      '6888c7acedcf1580f49a1430',
      '6888cd296994670014baa85d',
      '6888e061049ce5f10c8bccac',
      '6888af009a1b1c49055281c3',
      '6888cebdbf819a0015a5561e',
      '688744a25e9529c54e4f990c',
      '68873f8d7db1fa0434ae281f',
      '688391cd71080734648c6ed3',
      '688745ac1da6e411ee33212e',
      '68873a5bb5c429d75e2a02e7',
      '68873ba97db1fa0434ae262c',
      '68873dfb7db1fa0434ae26b4',
      '6880f8f2de67d20014912ed5',
      '5d9d06c4f72a746e59a9035f',
      '6887264705e82747a9908ffb',
      '6880d84abf5904a3bd75ed81',
      '687f456c851394caa2324ca9',
      '6877bfe5a777307058e00923',
      '60210c2f2c7fcc0683733559',
      '6877a7dec2d9169e1d9d4253',
      '6853ce7442cf6ebc756d9f48',
      '68764cf161f4616d11da9b28',
      '68760b0a1d7fb5838c0cfdcc',
      '68760a61e0601cec0aee172f',
      '65dc94230b6a3439c69ef203',
      '6878e4fcba883c6f7faaf811',
      '6875153a900b23b48641cbfa',
      '6874bcdae4f289797b582576',
      '67a9f90fe9ced188f025a0c4',
      '6560c0a51f6d778b4f28673e',
      '6874c37a55a26cd5083ad579',
      '60d051b67244095cdd00d4da',
      '6407328973303f9006c821a9',
      '6874b6730526ad7db6118e1b',
      '654a0c8de655720602b58a7e',
      '686548a4dadfc4ecd1c7dbd0',
      '6694fc859ad192b81df2ad27',
      '686b8f36172f0a012b26435b',
      '5d9de044f72a746e59a903d1',
      '5f6a0b31064940248e1b90b7',
      '68654a6715c9ff5c3724804b',
      '6863a9eb9d1a08d2e24e3d1e',
      '685e865c9db22e42103a1467',
      '68639db22c7eeed8d3429fe4',
      '685a6cf80ebe6c10b1cb7364',
      '685a7dbaeb148083947e85bc',
      '64b7db3fc801a70a10f41bab',
      '64076ca273303f9006ca4de9',
      '5dd3f95a245dd830d3abb13b',
      '685aa7891a5494f6402e02ca',
      '655f4bfb1f6d778b4f2425e9',
      '685912cd4ca5abba8ae91254',
      '68590ced4ca5abba8ae9115d',
      '6853ccf750fdd684cba13d42',
      '6859168005722a1c2fc5d6e6',
      '67e4f88b666cf3c16ddd91e6',
      '5f0c160b111127558580a14a',
      '65549e61e655720602cb9fc1',
      '68525a5b623b398855754f69',
      '5d9de7fcf72a746e59a903e9',
      '67c1da09e7fb743de0f3a28d',
      '618425855bf9b25149507ee8',
      '684a7ddcaaeabbdb2b6b6651',
      '684ac510d03f00620841f5df',
      '61798f8f877daa129494389b',
      '685020dcbafba8202a775ecc',
      '684ac62de37a82cec6981301',
      '68485806001667749ce7c5ec',
      '684ab7de45e708b3d9b1ef55',
      '65dc815eaf459a8e3ec26f8f',
      '684812632a05cb9b8af3cbef',
      '685000487217cf3d0f4aab8d',
      '6846a96309999c001a21f9ed',
      '6846a049e93f2f99d47d184e',
      '6847f2ff83f5de7c2db67e11',
      '6846a5d9372645001bd6bc42',
      '68469fece93f2f99d47d1826',
      '6846a4e1996c2d067bcfff83',
      '6846aac309999c001a21fb2a',
      '6846a2ea302bca839a0c6434',
      '642aa5d840578200e465084a',
      '6847ef8283f5de7c2db67cda',
      '6846a3f909999c001a21f4b2',
      '6846a2ebcd5653001b138c61',
      '6842f7447df74fae6d96887d',
      '6847f189c383acb96144bbdc',
      '6846ac18372645001bd6c07d',
      '6846a802372645001bd6bde6',
      '6846a1eb09999c001a21f19b',
      '6846af50cd5653001b1396d7',
      '6846a6da996c2d067bd00053',
      '5f0c16df111127558580a14f',
      '683ec2d9eb912e019d3e77da',
      '675850bca04eee42a80a6a1c',
      '68219f2ac557305b766d7e0c',
      '682c79afb688474f45b48605',
      '682dc708905531cd97a0e8bb',
      '682c7b9ac050a09a8b699688',
      '682b342cd8ee30c33db042a2',
      '68273da10af8287989c42b86',
      '682352e3980ac02a1d2ca0b8',
      '682afd8a650b02aa031c4224',
      '6822ee07b9d3f6fa810aefa4',
      '681c62f49dea9ac2e0a280bb',
      '62fca4d264de1d5aafea7a24',
      '6818decb7f0fb1c3c0871337',
      '681b64383d4b6468105e730d',
      '6686aa2382f611eb8ee4033b',
      '681b6baa976debc31dbeb24f',
      '681b723c26de7824606e63d7',
      '681b6a7589d2e16d808eeff9',
      '681c5ff79dea9ac2e0a27fb7',
      '681b5c51a1ad4abf77c6d450',
      '681098fdaeb6040501398625',
      '680f925ee1c3a24591116d15',
      '680b539210b810de15382e7b',
      '680b7529a3170964b6d87a64',
      '680b87b68926117d0d85bce2',
      '680b5b1c48e959fabc345271',
      '62553b188fa9f4371e3cb909',
      '68010735a687dafd9646f530',
      '67ff666e3e267444dfaece7e',
      '67fcfc791d0bffe5ee362655',
      '67fe47ed32e2840c0c6643e3',
      '67f66a62e69625a552295dbb',
      '67f8e195e93f529480bfcf53',
      '5d9cfd23f72a746e59a9032d',
      '67f8d733d843a607a16d97e4',
      '5fc4fcbdc8019009eb6b3288',
      '67f5094822f54e08e10ab715',
      '67f645b6909831c49f57aff1',
      '5dd540ad245dd830d3abb1ab',
      '67f398776727df0ce24fa38b',
      '67f38f01c907f167a91325dc',
      '67d2ad28f09559b5b858251d',
      '67e6c3351b4172a8e7ce0d31',
      '67e6c459aa5cacf39f288155',
      '67ed0a38b8c0df7e33b9579f',
      '67ed071a1b92ee8fd7f5c1bf',
      '67e6bbdc61f7eebbeba914af',
      '67e6c4ec4dcd95c6082760f7',
      '67ed08bd1c6a6ab07a1b2d01',
      '67ee40c4c944044068a4acf5',
      '67e2cc6fca2dcd78cbc37fec',
      '67dade78b0c53d8e56c8826c',
      '67d987b5138ca7debc24bc7b',
      '67dd5fa349d91721a4ddafa6',
      '63dd16093c5b78d7450c90c3',
      '67dc0a527779f67954d29399',
      '67d7f0f853f75281f569f0b8',
      '67d44fd4344df61d9cb625c0',
      '5f4e48616f3ad206888444f2',
      '67d4509e344df61d9cb626b6',
      '67dad6bb3e0777b3e889f0cd',
      '67d810c309def3f1f4d13cee',
      '67d44fb4344df61d9cb62596',
      '67d450a0344df61d9cb626e4',
      '67dad7dc063e5ffe9341b3bd',
      '67cb07044d5650e072f9b0df',
      '63a3a8368aaa3ed8d0030219',
      '6446758101972e8c023352cb',
      '5d9ef6e06e558970c974fe0f',
      '67c5b4f4fda20e52e4cad909',
      '67c6f57f68d3d4509ff1ca0d',
      '67c198189cd2ecab87c1dead',
      '67bc9453fdaaf095dc03ef89',
      '67c5aa3bd7cd23996c6f2fb6',
      '67c5abeafda20e52e4cad761',
      '67c1bdbbaf16673a21bcfce1',
      '67c5b3f7fda20e52e4cad8c7',
      '67c6bfbcd5743e1bf2fcab4e',
      '67c6f40f4e0cfa47e022b3a8',
      '67af55217ff79f3d6409014e',
      '67b5ad99bc2f18bc70a7c85c',
      '64bf7b7cc801a70a10032eb0',
      '67ac73c8d682b18ed5d101a1',
      '67ac5d8cbba966a7e5d499d4',
      '670ceef493633e8f965d52cc',
      '67a9fc7ee43f6030cc5e6d58',
      '5d9cf4f9f72a746e59a90308',
      '67a47c0d5873305ccde77f04',
      '67a4be8a780153a517a5f4af',
      '67a4ce6d32a400827fe7eb17',
      '67a4d5f84062a45fe0da6ecb',
      '67a496aba7834d560a8a7f2b',
      '67a4804d4c0b09001bc90ffe',
      '67a4bc651e21d94e5c4b7d5e',
      '67a9e4557b16910014c63088',
      '67a237e48efa884c25a14037',
      '67a09530a09acc1c02f8a922',
      '67a228cad69af5616340c38d',
      '67a09666a0ea0f07a3015b9b',
      '679b893111e3ff0013a930ca',
      '67a090d0bf01b3f324f701ec',
      '6798f4041b16fe11309227d3',
      '67989d0405970c7c169daf20',
      '67989707022642983f88d110',
      '6798842687ec6bc0e4ba5699',
      '6798a2f0c7c7b80019961fd6',
      '67975f9e84876b4ee0c9f42a',
      '67a0b4b668a1a92e4f7892ca',
      '6797afcb32d8678cee1632f8',
      '678fc35f37b8147c50c2e29b',
      '678f634403e29c6d3f3dbc5c',
      '6790c70cb3a7e8022e13c6ca',
      '678e2954b53a36ef89f9b3b0',
      '638672b08aaa3ed8d0a795c5',
      '677bff0f53c860daf256046a',
      '677bb206cfa1eca981f7fed9',
      '677bc5900ff960e05f66c7fe',
      '67726cd8b3ba288783dcb5f1',
      '67766384211851001a9a3a62',
      '676e999a3950ee317e228425',
      '676a755f14d9d42b23210f3b',
      '676935a508d367d2b0d7f344',
      '67692b8ddd0062001add08e9',
      '65faf8be223cbda97a01759a',
      '675fec7dd12d1978e4892f61',
      '675ff3de2a713e06bc4ec91b',
      '675ff4e82a713e06bc4ed10c',
      '675ff15787eb897c3349d478',
      '675aa4de27e6a1d575a7fa53',
      '63f48f2d73303f90066667ca',
      '67584bdfa04eee42a80a6916',
      '675852578cdb1741b45fe43d',
      '675843889277c330ff053d4b',
      '6756b70a5ecac5c05995f192',
      '6756b3df637684ed6a2a18b7',
      '6756b30b637684ed6a2a1861',
      '63a9575f8aaa3ed8d0123414',
      '5f58ccf468f6320dd75ff1f0',
      '674d94e24f00f8bee3d2058f',
      '674595f8f9df3518caa83d06',
      '6746f1e83df3e68f97448f95',
      '67459123f9df3518caa83c6e',
      '5d9d0690f72a746e59a9035e',
      '674454f561835f50fd11ec85',
      '6744412eac027ab5e5a81ffa',
      '674443f6ac027ab5e5a820af',
      '673ee71c7eed389dcdcaefd0',
      '673f5a722d9b477c36edd395',
      '673f5c0498835c5cd3ce44f6',
      '673d97094d104617a6a421da',
      '673b0964ec04d68745787fd3',
      '673dd25657368a77a9da2b24',
      '641aba8340578200e424dd0c',
      '6731d2bcf029b767ed3a8e32',
      '67321f0cf39fd44f4cf94ed7',
      '6731c533976a623e86aebc2b',
      '5e188d9e57dec554ee11ecd3',
      '672a0f6cf6686854c24ccf60',
      '6728ce9fa0cc20fde4f008eb',
      '6728c2cdcac174be166fa5e1',
      '672890d8fd317005a89c70bf',
      '6723505982a4c16ef379b2a7',
      '672203b41ac98f4719d4fe76',
      '671f5b23e10ddc1bee8ba283',
      '671f86992dc98732bdb8a1f8',
      '671f91957c662c2765e6eaad',
      '671b82fc2053843b6d2432b0',
      '6718ee193bf2b6a16449226f',
      '648c5977d1b38e7ebe713bcd',
      '6716446cc26ed38129e13284',
      '67165b3cfd317005a8652e8c',
      '67179abfe5154bcb0a5ef54f',
      '670fa147207e5ae66dea5eb0',
      '670d1da1989f78cc704c36ce',
      '670d0fedfe8fedbe82e3a84f',
      '63b7e1518aaa3ed8d04e0ac6',
      '670d19336e8c9232226d0430',
      '670d0b9cf18a9aae73591ab7',
      '6708f57d602b30988245f8f3',
      '67053eebdea77a5429072e70',
      '670523ea8732b28ca08c7a1b',
      '6704f4b268c48c6046d3d877',
      '6707ce0c0a0606b6c7bd9090',
      '67063058023745458fff7512',
      '670550f2d63a7a46c3a9dce9',
      '6537cd15cc4eaf7f9533a25f',
      '66fd0d77a46db7b1dfbae18f',
      '67039e9e70187c845bfad964',
      '6703994e70187c845bfad7ec',
      '66fd022a2d7add7525d47c5b',
      '66fc06f234c5994592a0a20b',
      '66fd06e32d7add7525d47dc8',
      '66fbd8788a780759d1b095c6',
      '66fc02723aba8a6162a9354d',
      '66fce71349ff020b455e5a1d',
      '66faae9474b06f0d21b698df',
      '66fbfc3b534a447d357dc79d',
      '66fa6e8468c48c6046a3662a',
      '66fba0fdb436e369e4209a27',
      '66fba33829a01c39df192f56',
      '66fba3bdea50109bcff843a7',
      '66f514622e3ce77c3d457db3',
      '66f536b0aea701d40f371586',
      '66f53bfc548520e04235081d',
      '66e93154970d31989491ffdf',
      '66e7f06c3c287978b6f30278',
      '66e92f88970d31989491ff98',
      '66dee2d1753b23a5a65e4ade',
      '66dede725e5f9f8584cff910',
      '66dee6eb0af9e2565e61f568',
      '66e17fe8c272caff8f9065c5',
      '66def6e3245a4b49b6da17e1',
      '66d9befae9767286c16daa3f',
      '66d97c95dc9042c6a34a4ea9',
      '646b33bb27e0949da90eb1b7',
      '66d58860208fa23f286a379b',
      '66e03943c5cc77f3201e28dd',
      '66d07e609f84e53e972eebf3',
      '66d0811b95ab05293858e3b8',
      '66cc4e7ebcaa3366bcd49db1',
      '66d5809250423a1da748b65e',
      '5d9f23706e558970c974fe6b',
      '66c6ec79598dc9dca04a1da3',
      '66c707959b1d87d28206603f',
      '60c09b51245a503dcfb3a6da',
      '6179b066877daa1294946d6b',
      '5ff322f32c7fcc0683728971',
      '66bdb08b055c0162542f2fbb',
      '66bc984e587bbd129eaaacfd',
      '5f5f583868f6320dd75ff970',
      '5d9dae81f72a746e59a90387',
      '66b08cd014540dde95c4508e',
      '66aa2d747f53bc20f9e3c9ad',
      '66a8adc1f6d3bebf53f3add0',
      '66a8a7e6474d06cc52ad53dc',
      '66a7ae56e9b2b969efe58b63',
      '66a356e0ba748f4c606393fb',
      '66a7aa31c08e999fcf463b92',
      '66b0e731c72680fca683f9ed',
      '66a79d34cbdd588f5f5c7d20',
      '66b0e4cb8f9c0c2a72796204',
      '66a209fcef65d891864f0855',
      '6697c4b1cb363c0c27bfa78a',
      '6697c7aa8984169476629606',
      '5dd53ba2245dd830d3abb19d',
      '66979309639ebb06ed354e54',
      '6698c755b65aa5f213b4a0ea',
      '63cfa4333c5b78d745dec709',
      '6694e9e22dd6a3878ba37cac',
      '6697c1cbd95d316486ab96ad',
      '668bdbb8aaa92e10726a2c88',
      '6687f54a54a45851b8f41f4f',
      '66864c7318e7f4911462a0bf',
      '668660526537051a296d85e0',
      '668500b6dc0982d1bcccc646',
      '5d9cff87f72a746e59a9033b',
      '66839fead7c5be85c24b25d0',
      '6685625b867feb3f8d32abad',
      '6682b173ae9965b53fbbe047',
      '6683af1a5596010a2849a4ea',
      '628236cd8d16b01ee48d8d59',
      '6686a5ca6f572e08617f9708',
      '667a6ec1a27ac42c3389932b',
      '66796d063ae52ca74f2543a3',
      '666fe4cf4876f122c20da809',
      '667429dce339562d51e96e46',
      '667966b33ae52ca74f2542d8',
      '6666a873634bdb28909bafe1',
      '6666ad5e5bdcb1fdbca2e13b',
      '66670596a62f5a58db6732a1',
      '665ec6bd322d21b8f0454bec',
      '66597b258ae5bd02f5baee3c',
      '664c97e7a2d66dbedff6451e',
      '66433d1b6e4d385f9c3b669f',
      '63867f288aaa3ed8d0a7a2db',
      '6645d83b1ad5320fbce2e72b',
      '66334a05f222b750ee2d44f0',
      '663347eb7b48d582a46257a0',
      '6630f684c846049d7d5ba6bf',
      '662fa54a9ee98ea41a095e22',
      '5d9f222b6e558970c974fe66',
      '662120daed96bef56919236a',
      '661ce88c147b8f217bffa48e',
      '6617b5c7d4b492afb0db3d79',
      '660bd6e88cecbc8bca22a607',
      '660d02dd2a9668084a3a7d5f',
      '660280175837e96b91f39b3f',
      '6603fbc6454cfcaa0f95a701',
      '65fc411e719ef30f76ad3ebf',
      '65fc08f8bd0fb44f5829d554',
      '65eed34567dba79dbd83c47b',
      '65faf96a71ad5471c191c166',
      '65ef219315f1a5e8fcaa5e1f',
      '65e97fc936e4dc491dad9571',
      '660138f02498b9b0710dbb15',
      '65e6ec2be4e5fe2074ae723e',
      '65f02266095dcdba2c8bd04e',
      '5dd3a39e245dd830d3abb0cc',
      '65d4b09486c730fb0c06a93c',
      '65ce2259ac4bfaa9277ab76f',
      '65cb471dac4bfaa9277293a2',
      '65cdd649ac4bfaa92778fd8f',
      '65c2412402bc6a66cda9c514',
      '6231a8258fa9f4371eeaa33c',
      '65ba5110fe48df74311dee78',
      '65ba48d7fe48df74311db05a',
      '5de8dd1040a5b4067c720570',
      '65bcabb9a56f0bf274357053',
      '65ae47fbfe48df7431fba5b7',
      '65b0fc6da7db372ca979e9f2',
      '628233ab8d16b01ee48d52cc',
      '65a643aed03cddd483c5e588',
      '61c1b44cf4c339b6a0cff7ec',
      '5d9f27196e558970c974fe79',
      '659e862d01ad7fa536fbdd18',
      '659e58763fcc940fddc8e3d4',
      '659d08ad9d4d72d0b549559a',
      '65c0a496e4bcdc1dfc0a0f3d',
      '6582d9c4fb119a1795321555',
      '6580616dfb119a179529da6d',
      '65801098fb119a17952786cd',
      '5dd554ca245dd830d3abb1cb',
      '6572dda3fb119a17950d272e',
      '65772ac9fb119a1795141d4d',
      '65815b9dbdde7d360785055b',
      '65782827fb119a179515e498',
      '65688ecf1f6d778b4f3c1e67',
      '656892951f6d778b4f3c3b0b',
      '6572f592fb119a17950def6c',
      '6565c4ac1f6d778b4f30b065',
      '638581ee8aaa3ed8d0a42a03',
      '5d9ddd13f72a746e59a903c7',
      '656453ea1f6d778b4f2b8b13',
      '6357c4eca234e62f59d2abc8',
      '65548cede655720602cb35ad',
      '6079b2bfd80dab068a7453de',
      '63d7f2033c5b78d745f82aea',
      '63f727c173303f900670a070',
      '658061f12dad0fe8dc2f757a',
      '655f86741f6d778b4f254ad6',
      '655f29631f6d778b4f2375c8',
      '655f3edb1f6d778b4f23dba4',
      '5d9cfcbff72a746e59a9032b',
      '6540d4b7a287e406d49d6cbd',
      '653a832e9161580a3f1ee78e',
      '646729d827e0949da9091a17',
      '653a857c435d0708e4849fa5',
      '653a7a78f57f47c5c19a71c0',
      '653f970fa287e406d4987a93',
      '6537bfd39161580a3f16df5a',
      '6540d2d5a287e406d49d5e47',
      '653a605be7ea49679e88dc17',
      '653fa328a287e406d498dc28',
      '653fa78fa287e406d49908a4',
      '615d783264959e3f7f830fde',
      '653668d09161580a3f1350c5',
      '653fa174b5c77d8c7f845f7e',
      '65378e949a24822cc0b0acf4',
      '6537e25ce82860ebae280895',
      '6538fe0e9161580a3f19c5ed',
      '6537e75b25d369c13c627e8c',
      '653663919161580a3f132e2c',
      '616d881764959e3f7fafd3aa',
      '652f9b7a9161580a3f076ffe',
      '6523c15f9161580a3fefd41c',
      '6536842bfb26172121526ac3',
      '6526ab5e9161580a3ff83038',
      '5d9da805f72a746e59a90379',
      '651411b09161580a3fb9dd7a',
      '6502a9199161580a3f96f96a',
      '65085db29161580a3fa0afbc',
      '650048839161580a3f915605',
      '64e5aeebc801a70a10743778',
      '64df7626c801a70a106a1d8b',
      '64d22b3ac801a70a104ba580',
      '603e0f9bd80dab068a73739b',
      '64db8fa9c801a70a105e957d',
      '64bf84e5c801a70a10038d3f',
      '64be2a1bc801a70a10fe0ce2',
      '5d9ef7306e558970c974fe10',
      '64b6ab606e6adda9b934c727',
      '64be6c86c801a70a10005cb6',
      '64b7e573c801a70a10f46688',
      '5f90342add22357fbcef623b',
      '64a7dee1c801a70a10cff6fd',
      '649d8f6ec801a70a109cdde4',
      '5e8460fca6152815d8f14a21',
      '649d73ffc801a70a109bed3b',
      '649ad7c6c801a70a10936f34',
      '649d914cc801a70a109cf1eb',
      '605afff0d80dab068a73ecfe',
      '649aeaeac801a70a1093fc9b',
      '649af9cbc801a70a10946171',
      '631757c4a234e62f5945fd7a',
      '649ae10fc801a70a1093aca4',
      '649aa6c44d7223c2790dfe63',
      '5d9df23d6e558970c974fe07',
      '649adcfbc801a70a1093934d',
      '648c4741d1b38e7ebe70d1f0',
      '649067e2d1b38e7ebe769a9b',
      '5e57e282ecd40b7d9467d1fe',
      '6489a13dd1b38e7ebe69d473',
      '5d9d00dff72a746e59a90342',
      '648c746ad1b38e7ebe71c84b',
      '648c5c7fd1b38e7ebe715316',
      '648c488ed1b38e7ebe70da30',
      '5dd3f9dc245dd830d3abb13d',
      '5d9d0018f72a746e59a9033e',
      '648d688ed1b38e7ebe72748e',
      '647860cec5943ad7c5ca5ef6',
      '5e60f8bc05dd424259bc6190',
      '646b164927e0949da90dd596',
      '646b183727e0949da90de03c',
      '646727e227e0949da9090f32',
      '645b51e427e0949da9efdace',
      '645b549f27e0949da9efed7d',
      '645b506a27e0949da9efcc40',
      '64550d7827e0949da9dda5bf',
      '61dd897e08ce61caceb8d333',
      '644656d82a099539ed3ba663',
      '64467e778422a203757415ae',
      '64467734042b1f88ade99c48',
      '6446703d01972e8c02335094',
      '644a7a6d291c954425fa38c1',
      '644a7d37291c954425fa839d',
      '644a73e0291c954425f9f111',
      '6447d75b8422a2037578904c',
      '6437e0ba597f187f3bc0d5d6',
      '6437d604597f187f3bc0a81f',
      '6437d7e3597f187f3bc0af91',
      '642aacac40578200e4653d58',
      '642aab6d40578200e46534ad',
      '642aa22540578200e464d873',
      '642a9dec40578200e464a159',
      '641d995d40578200e4326127',
      '6414895073303f9006faa2f8',
      '64148c6373303f9006facf84',
      '62a7666864de1d5aaf22ab99',
      '6409f9c773303f9006d81b11',
      '64076ef873303f9006ca5433',
      '63fe00d973303f90068ae40b',
      '6406252e73303f9006c46012',
      '63f76ef873303f900673325c',
      '63f7733b73303f9006734952',
      '63f77d1373303f9006739437',
      '63f775c673303f9006735755',
      '63f7a19073303f900674306b',
      '63f79efb73303f9006742df4',
      '63f7993f73303f90067420dc',
      '63f79bd573303f900674272d',
      '63ee204073303f90065a450a',
      '63eca6883c5b78d7454e6fba',
      '63f8d1ba73303f900677c603',
      '63dd2dd13c5b78d7450de3cc',
      '63f88e7773303f900675cd6f',
      '63f892db73303f900675e1b2',
      '63e13a013c5b78d7451d24dd',
      '63f890c273303f900675da43',
      '63e137443c5b78d7451d053c',
      '63dcde4d3c5b78d7450a793e',
      '63e12c6c3c5b78d7451c616c',
      '63d909d83c5b78d745fbe660',
      '63d3afbf3c5b78d745ee68d6',
      '63d7d9523c5b78d745f71d1f',
      '63d3bcfe3c5b78d745ee9b44',
      '63d3b5723c5b78d745ee7c21',
      '63d3bff73c5b78d745ef12da',
      '63cfb1da3c5b78d745e020b2',
      '63d3de5a3c5b78d745efc6f0',
      '63caaac922fc77900f7472d0',
      '63d3ecd63c5b78d745f01e83',
      '63c8312f22fc77900f66a152',
      '63d2e9513c5b78d745ec51ae',
      '63d2ae843c5b78d745ec170b',
      '63c82e3922fc77900f6699fb',
      '63c9647322fc77900f6a1e53',
      '63c582638aaa3ed8d07c2749',
      '63c155588aaa3ed8d0772732',
      '63b7ddd98aaa3ed8d04df7f9',
      '63b7e1308aaa3ed8d04e08ba',
      '63bfd4a28aaa3ed8d071e5f4',
      '63b7f8cb8aaa3ed8d04edda9',
      '63c9334b22fc77900f6921fd',
      '63c80fda22fc77900f6616d7',
      '5f4e40a36f3ad2068884445d',
      '63ad62238aaa3ed8d0308115',
      '63c03e668aaa3ed8d074e383',
      '63bc40d28aaa3ed8d0607068',
      '63bc3f198aaa3ed8d0606256',
      '63bc440c8aaa3ed8d0608820',
      '639c8b488aaa3ed8d0f3ff6a',
      '639c88d68aaa3ed8d0f3f51f',
      '639c87918aaa3ed8d0f3f128',
      '639c84c18aaa3ed8d0f3e34e',
      '6391b0f48aaa3ed8d0dec498',
      '63a383ff8aaa3ed8d002c1e7',
      '6388671a8aaa3ed8d0ac7def',
      '6388653c8aaa3ed8d0ac7263',
      '63861ca38aaa3ed8d0a6e975',
      '63861bac8aaa3ed8d0a6e69c',
      '63861a108aaa3ed8d0a6e309',
      '638619098aaa3ed8d0a6de29',
      '6386152e8aaa3ed8d0a6cb3f',
      '638588bf8aaa3ed8d0a42be0',
      '63868fc48aaa3ed8d0a7a7ba',
      '638522218aaa3ed8d0a41b6c',
      '638587368aaa3ed8d0a42b97',
      '5ffd762e2c7fcc068372c01f',
      '63866e008aaa3ed8d0a79030',
      '63876f858aaa3ed8d0ab29dd',
      '63858ab98aaa3ed8d0a42c29',
      '63851f4b8aaa3ed8d0a419e6',
      '638670488aaa3ed8d0a7926a',
      '638779bf8aaa3ed8d0ab6438',
      '63876ced8aaa3ed8d0ab1ddc',
      '636c12088aaa3ed8d0703f64',
      '636c1ab68aaa3ed8d070413f',
      '636a9e0d8aaa3ed8d06c6bbe',
      '636a99388aaa3ed8d06c6659',
      '6369091f8aaa3ed8d0673d66',
      '636a94f88aaa3ed8d06c5e3a',
      '636947c48aaa3ed8d0683ea8',
      '63694add8aaa3ed8d068416e',
      '637287d28aaa3ed8d07c3303',
      '6357931ca234e62f59d0fcaa',
      '634d571fa234e62f59c3ab9c',
      '6353e8e5a234e62f59cd433d',
      '6353e70fa234e62f59cd42f4',
      '6353e53ca234e62f59cd424f',
      '6356c2f1a234e62f59d0779f',
      '6356bf5da234e62f59d01fa3',
      '634422aca234e62f59b5774c',
      '633d3a46a234e62f599ca26e',
      '634ebf83a234e62f59c68073',
      '632c1b53a234e62f596c19ca',
      '632af0d5a234e62f596a40f7',
      '632ad74aa234e62f5969e31a',
      '632adcdba234e62f5969fe67',
      '632affb1a234e62f596a8865',
      '632ad32ca234e62f5969a4b9',
      '632ad90aa234e62f5969ea7e',
      '6316f363a234e62f5942a9ed',
      '6319f59ea234e62f594cde86',
      '63172e93a234e62f594492f2',
      '6319f15fa234e62f594ccb0d',
      '6303774f64de1d5aaff32507',
      '62fe09d264de1d5aafed824d',
      '62fca14564de1d5aafea6d12',
      '5d9f11046e558970c974fe34',
      '62fdfc8e64de1d5aafecf64a',
      '62fe036d64de1d5aafed138b',
      '62ecc25164de1d5aafcdc612',
      '62ed0ffd64de1d5aafd02455',
      '62eccc4c64de1d5aafce48dd',
      '62ecc0ac64de1d5aafcdb1de',
      '60c874eb245a503dcfb3ff82',
      '62e38d6e64de1d5aafaf42b2',
      '62e3810b64de1d5aafaf03b5',
      '62d92ddd64de1d5aaf9bd463',
      '62d91ed564de1d5aaf9ba500',
      '62d9242064de1d5aaf9bbce3',
      '62d925e464de1d5aaf9bc34b',
      '62d920c464de1d5aaf9babef',
      '62d9212564de1d5aaf9bacfc',
      '62d9225964de1d5aaf9bb39d',
      '62d91d4f64de1d5aaf9b9ef7',
      '62cbdcab64de1d5aaf7e3276',
      '5e57dc67ecd40b7d9467d1f5',
      '62b9a79264de1d5aaf4364ee',
      '62bea6fe64de1d5aaf4f0925',
      '62beb5cf64de1d5aaf4f6dda',
      '62b41e3764de1d5aaf39d33e',
      '62b4183764de1d5aaf39aac2',
      '62b422ce64de1d5aaf39f638',
      '62b2c7e964de1d5aaf36a580',
      '62bea5ce64de1d5aaf4ef9d4',
      '62be9c2e64de1d5aaf4ebb48',
      '5e60b41605dd424259bc60c0',
      '60fff4b11d72340851354954',
      '62a9af5064de1d5aaf270bf9',
      '62a7722264de1d5aaf22bcdc',
      '62a7008664de1d5aaf20c746',
      '628f3f8764de1d5aafd7725a',
      '628ce0f564de1d5aafd20b6f',
      '627cb6cf5d75a15c362093cd',
      '62823ae88d16b01ee48da5c6',
      '62823c658d16b01ee48dab47',
      '6282362f8d16b01ee48d8a0f',
      '628241518d16b01ee48dbee1',
      '628237fd8d16b01ee48d9700',
      '627136165d75a15c36fdc177',
      '6272922f5d75a15c3607ca80',
      '627134015d75a15c36fda452',
      '625587c58fa9f4371e3e2af6',
      '6268e12b748d3f4c64754e0c',
      '62595ef58fa9f4371e468886',
      '625940e68fa9f4371e463cb1',
      '626bac175d75a15c36ef901c',
      '62552ab58fa9f4371e3c5c5b',
      '62556bda8fa9f4371e3d9ca1',
      '625562738fa9f4371e3d736a',
      '625535538fa9f4371e3c957c',
      '625ea1a48fa9f4371e4c56a0',
      '5d9f19596e558970c974fe45',
      '6270d91a5d75a15c36f8e717',
      '62397f698fa9f4371ef72024',
      '62455ce68fa9f4371e0b9fff',
      '623ae9b08fa9f4371ef9a13b',
      '624562818fa9f4371e0bbc3a',
      '624448ef8fa9f4371e09a280',
      '623addbd8fa9f4371ef972c1',
      '623312358fa9f4371eede52b',
      '62332ace8fa9f4371eee37cf',
      '6231b84b8fa9f4371eeb1db5',
      '62305c048fa9f4371ee813cb',
      '5d9f19256e558970c974fe44',
      '62305d798fa9f4371ee81978',
      '6231e5f78fa9f4371eebd71f',
      '6231b2508fa9f4371eeafa4b',
      '6231a4d08fa9f4371eea9109',
      '6221e37c8fa9f4371ec1ab64',
      '6217575e8fa9f4371e9e2420',
      '621502de8fa9f4371e9a1418',
      '620e50198fa9f4371e8e037b',
      '621cf03c8fa9f4371eaacbd2',
      '621763d18fa9f4371e9e6383',
      '620d1b1d8fa9f4371e8bf766',
      '621cf6558fa9f4371eaaed51',
      '620640d28fa9f4371e81e5eb',
      '620641e68fa9f4371e81e94d',
      '620658038fa9f4371e824d74',
      '62063eae8fa9f4371e81dd2a',
      '5d9dec47f72a746e59a903f6',
      '6200f3758fa9f4371e72d56f',
      '6200fe0b8fa9f4371e734366',
      '6200f2a88fa9f4371e72caf8',
      '6200eb1e8fa9f4371e72801b',
      '61f28d0c08ce61caceda8279',
      '61e588a408ce61cacec4c90a',
      '616d68eb64959e3f7fae92e7',
      '61e586df08ce61cacec4c137',
      '61dd6f9b08ce61caceb85e4d',
      '61dd857508ce61caceb8bf14',
      '61e58c4308ce61cacec4d490',
      '61fceee88fa9f4371e6620d5',
      '61e57f5f08ce61cacec49f1b',
      '5dd69490245dd830d3abb209',
      '61c31b8cf4c339b6a0d3587a',
      '5de8d9c540a5b4067c72056e',
      '61d33054f4c339b6a0ee82f7',
      '61d32db3f4c339b6a0ee71c7',
      '61d5b156f4c339b6a0fad0ae',
      '61d3353ff4c339b6a0ee994c',
      '61b8b67d94091a23e1345d21',
      '61c2d735f4c339b6a0d1fd62',
      '61c32020f4c339b6a0d373da',
      '61af232be210d6f258e668ff',
      '61c193a2f4c339b6a0cf4e48',
      '61c09ecff4c339b6a0ce2a9d',
      '61c1db27f4c339b6a0d0b63b',
      '61b0a42ce210d6f258e9fa41',
      '61a0b1256ffe503e6f60145e',
      '619d3b1c6ffe503e6f56b1e3',
      '619d387d6ffe503e6f56aeeb',
      '619d2f056ffe503e6f569d71',
      '619d204e6ffe503e6f565fb9',
      '619d3e176ffe503e6f56bd3f',
      '6179ae15877daa1294946b1e',
      '6179a2dd877daa129494593d',
      '617fc8255bf9b2514920a90c',
      '618424255bf9b251495063ea',
      '6179ab80877daa1294946812',
      '617135eb64959e3f7fbd4cd3',
      '616d76ea64959e3f7faf33c2',
      '616e81cd64959e3f7fb1affa',
      '61652dfb64959e3f7f97a8e8',
      '5d9de0daf72a746e59a903d3',
      '619b97a75bf9b251499d714c',
      '61652ed464959e3f7f97a9eb',
      '61669c0564959e3f7f9d417a',
      '615da9e664959e3f7f84b34d',
      '615ecf9864959e3f7f8895b3',
      '615eba1964959e3f7f880d85',
      '61556a7364959e3f7f5398c4',
      '614dd1de64959e3f7f372c96',
      '61545bef64959e3f7f4f62d9',
      '61571d7164959e3f7f5f9859',
      '613f31c164959e3f7ff73e10',
      '612f256d8e9c892fc842cda5',
      '612c96908e9c892fc8303606',
      '612d05ba8e9c892fc837962a',
      '612e40f88e9c892fc84064ed',
      '612364b1400ae32df8f3d8e7',
      '612cf53c8e9c892fc8374624',
      '6125f525400ae32df8fe5bfd',
      '611a17a9ec463106484c734f',
      '61289bc8400ae32df80a5350',
      '611237b1ed34205c3a631a49',
      '610256790de1e543954cd43a',
      '61010a301d723408513559af',
      '60f7ce745b3ea0533f7cde40',
      '60fa6dee1d7234085135074f',
      '60f831bf5b3ea0533f7ce173',
      '60f9450a1d7234085134f702',
      '60f9493b1d7234085134f729',
      '60f924781d7234085134f59c',
      '60fa76781d723408513507a8',
      '60f91df71d7234085134f513',
      '60f1633c98c0de0878c2429c',
      '60f151fa98c0de0878c24205',
      '60ed89153e3ae27aae7d55e1',
      '60dca29694fa422ae1492fdb',
      '60dc41a1fe41b4234e599238',
      '60dc9b1194fa422ae1492fb0',
      '60dc93ab94fa422ae1492f7e',
      '60dc994b94fa422ae1492fa2',
      '60dc5c9bfe41b4234e5993b1',
      '60dc3c90fe41b4234e599207',
      '60dc9c0d94fa422ae1492fb7',
      '60c9f0a8245a503dcfb4115d',
      '60c9b354245a503dcfb40f80',
      '60cb19ce245a503dcfb41fde',
      '60d2f40b3c84da14e41cc5a0',
      '60c0c811245a503dcfb3a8b3',
      '60c08f53245a503dcfb3a67c',
      '60bf3904245a503dcfb395f7',
      '60c09d38245a503dcfb3a6e6',
      '60af69290c4c9a0bad35c5ec',
      '60af684a0c4c9a0bad35c5d2',
      '60953dac297459014aedfae7',
      '60952ad5297459014aedfa15',
      '60950d56297459014aedf924',
      '6094f7b1297459014aedf84d',
      '6095088a297459014aedf903',
      '60a8caef0c4c9a0bad3599a1',
      '60a8b8bf0c4c9a0bad35995c',
      '6094e72a297459014aedf7a3',
      '60a8d0e90c4c9a0bad3599bb',
      '606c0d3bd80dab068a7431e7',
      '606c66bed80dab068a74376a',
      '606d806cd80dab068a743a76',
      '605a0c1bd80dab068a73eb9d',
      '6059d986d80dab068a73e970',
      '6059bb38d80dab068a73e8c5',
      '60533803d80dab068a73dca3',
      '605336a6d80dab068a73dc9e',
      '604f6611d80dab068a73d04c',
      '603f9f38d80dab068a738616',
      '603e0cdfd80dab068a737376',
      '6033ae8ed80dab068a73566e',
      '6033b067d80dab068a735674',
      '602a916b746d370673ca3435',
      '602a852d746d370673ca33ee',
      '602a7b35746d370673ca33c1',
      '602d43c2d80dab068a734729',
      '60224a792c7fcc068373390b',
      '60214e1b2c7fcc0683733713',
      '6017d1c92c7fcc068372f859',
      '600fe9c12c7fcc068372e3f9',
      '5ffd7f292c7fcc068372c06c',
      '5ffd79d72c7fcc068372c029',
      '5ffdc25a2c7fcc068372c19d',
      '5ffd749d2c7fcc068372c008',
      '5ff343c92c7fcc0683728a5e',
      '5ff348cc2c7fcc0683728a8b',
      '5fce4d887e591568a710c15f',
      '5fce4c777e591568a710c155',
      '5fc609dcc8019009eb6b365f',
      '5d9cf9e2f72a746e59a9031d',
      '5fb7bc411b0f1b22e6f746e3',
      '5faa7ec71b0f1b22e6f735ea',
      '5faa824c1b0f1b22e6f735ed',
      '5fb22b0b1b0f1b22e6f73ce5',
      '5fb233fb1b0f1b22e6f73d08',
      '5f857c5a064940248e1bce15',
      '5fa00b9f5fee9323a8e538ef',
      '5f7ad3c3064940248e1bb891',
      '5f9a933b5fee9323a8e52c68',
      '5f9a95675fee9323a8e52c7a',
      '5f4e57806f3ad20688844612',
      '5f3b84ef6f3ad206888429ca',
      '5f3a3f526f3ad2068884275c',
      '5f1e8ea1608dae18f202c558',
      '5dd4ff1c245dd830d3abb157',
      '5f155b3fe260af740ec2081f',
      '5f155bd5e260af740ec20824',
      '5e8ae7e2d0f0823574462a61',
      '5e845d9ba6152815d8f14a19',
      '5e82fd09a6152815d8f14798',
      '5d9f2b8d6e558970c974fe89',
      '5e57eb9aecd40b7d9467d212',
      '5d9f275c6e558970c974fe7a',
      '5e57dbe7ecd40b7d9467d1f3',
      '5e5777ceecd40b7d9467d1bd',
      '5e3a95ea19de6b5a83152d51',
      '5e3a93ef19de6b5a83152d4f',
      '5e20652957dec554ee11ef56',
      '5e20644957dec554ee11ef4b',
      '5e2031fc57dec554ee11eea8',
      '5e182f2e57dec554ee11ec99',
      '5e183bcf57dec554ee11eca9',
      '5e1854ba57dec554ee11ecbd',
      '5de8d6de40a5b4067c720565',
      '5e20317a57dec554ee11ee9d',
      '5de8de2b40a5b4067c720572',
      '5ddd4bfe245dd830d3abb3b2',
      '5dd69879245dd830d3abb21b',
      '5dd6971b245dd830d3abb213',
      '5ddb968c245dd830d3abb23d',
      '5dd551e4245dd830d3abb1c5',
      '5ddb9047245dd830d3abb22e',
      '5de4c500245dd830d3abb53b',
      '5dd56055245dd830d3abb1eb',
      '5ddb8edc245dd830d3abb228',
      '5dd53df2245dd830d3abb1a5',
      '5dd3a2fd245dd830d3abb0ca',
      '5dd3f60c245dd830d3abb12f',
      '5dd3b376245dd830d3abb0e0',
      '5dd53b1b245dd830d3abb19b',
      '5ddb8d4f245dd830d3abb223',
      '5dd54128245dd830d3abb1ad',
      '5d9de9b1f72a746e59a903ee',
      '5d9f10446e558970c974fe31',
      '5d9df4c86e558970c974fe0b',
      '5d9f2d576e558970c974fe91',
      '5d9da8baf72a746e59a9037b',
      '5d9f0dd86e558970c974fe28',
      '5d9f10b66e558970c974fe33',
      '5d9f28166e558970c974fe7c',
      '5d9ddf49f72a746e59a903ce',
      '5d9cf9baf72a746e59a9031c',
      '5d9cf85cf72a746e59a90315',
      '5dd65025245dd830d3abb1fb',
      '5d9f1fb26e558970c974fe5d',
      '5d9dc984f72a746e59a90399',
      '5dd3ba2f245dd830d3abb0ef',
      '5d9dada0f72a746e59a90385',
      '5d9dde54f72a746e59a903cb',
      '5dd557dc245dd830d3abb1d0',
      '5dd55cfe245dd830d3abb1de',
      '5d9daa38f72a746e59a9037f',
      '5d9d0526f72a746e59a90356',
      '5d9cfbe8f72a746e59a90328',
      '5d9d0727f72a746e59a90361',
      '5d9f2c346e558970c974fe8c',
      '5d9d0359f72a746e59a9034e',
      '5d9d049af72a746e59a90353',
      '5e60fa5705dd424259bc6198',
      '5d9deb52f72a746e59a903f3',
      '5d9cdd0f0832df6be7e49aac',
      '5d9dd40bf72a746e59a903b0',
      '5d9f1f736e558970c974fe5c',
      '5d9de6c5f72a746e59a903e5',
      '5d9cf606f72a746e59a9030b',
      '5d9dd9a1f72a746e59a903be',
      '5d9d07b6f72a746e59a90364',
      '5d9d0628f72a746e59a9035c',
      '5d9cfb25f72a746e59a90324',
      '5d9dea28f72a746e59a903ef',
      '5d9df46a6e558970c974fe0a',
      '5d9d04fef72a746e59a90355',
      '5d9f1e556e558970c974fe57',
      '5d9f1a5c6e558970c974fe49',
      '5d9da3fef72a746e59a90370',
      '5dd39cd8245dd830d3abb0bf',
      '5d9f2b176e558970c974fe87',
      '5d9f21f06e558970c974fe65',
      '5d9dcdc3f72a746e59a903a3',
      '5d9da59cf72a746e59a90374',
      '5d9efa236e558970c974fe17',
      '5d9cfd57f72a746e59a9032e',
      '5d9f15ed6e558970c974fe39',
      '5d9f20a46e558970c974fe60',
      '5d9d05b1f72a746e59a90359',
      '5d9ef7826e558970c974fe11',
      '5d9d0282f72a746e59a9034a',
      '5d9cfad0f72a746e59a90322',
      '5d9d05d6f72a746e59a9035a',
      '5d9d0254f72a746e59a90349',
      '5d9cfe96f72a746e59a90336',
      '5d9d04d1f72a746e59a90354',
      '5d9f1e8f6e558970c974fe58',
      '5d9cfff4f72a746e59a9033d',
      '5d9dcedcf72a746e59a903a6',
      '5d9df3646e558970c974fe09',
      '5d9cfc52f72a746e59a9032a',
      '5d9f20e36e558970c974fe61',
      '5d9de707f72a746e59a903e6',
      '5d9d0109f72a746e59a90343',
      '5d9df0ac6e558970c974fe02',
      '5d9efd956e558970c974fe20',
      '5d9d045bf72a746e59a90352',
      '5d9f10016e558970c974fe30',
      '5d9d0865f72a746e59a90368',
      '5d9f229c6e558970c974fe68',
      '5d9da99bf72a746e59a9037d',
      '5d9cf7e5f72a746e59a90313',
      '5d9cff39f72a746e59a90339',
      '5d9dd338f72a746e59a903ae',
      '5d9cfde5f72a746e59a90330',
      '5d9deabdf72a746e59a903f1',
      '5d9cfa71f72a746e59a90320',
      '5d9de3b7f72a746e59a903dc',
      '5d9ddab3f72a746e59a903c1',
      '5e33ff8adfabc5332136a836',
      '5d9d058ef72a746e59a90358',
      '5d9effc56e558970c974fe25',
      '5d9ef6846e558970c974fe0e',
      '5d9dc474f72a746e59a9038e',
      '5d9f28e46e558970c974fe7f',
      '5d9f25bc6e558970c974fe74',
      '5d9d00aff72a746e59a90341',
      '5d9da686f72a746e59a90376',
      '5d9da076f72a746e59a9036a',
      '5d9f22e36e558970c974fe69'
    ],
    nominees: [
      'Erisa Spahiu',
      'Adelina Preniqi',
      'Aulona Fetahu',
      'Bleron Muqiqi',
      'Erjon Mavriqi',
      'Ariana Krasniqi',
      'Armend Jaha',
      'Endrit Krasniqi',
      'Muhamed Emini',
      'Dafina Shabani',
      'Erë Osmani',
      'Jonila Beqiraj',
      'Perparim Makolli',
      'Vullnet  Syla',
      'Melisa Ademaj',
      'Arber Shabani',
      'Kaltrina Ferati',
      'Majlinda Ymeri',
      'Elmedin Syla',
      'Andrit Hajda',
      'Valona  Ramiqi Luma',
      'Blerta Gerxhaliu',
      'Florinda Shaqiri',
      'Adlije Syla ',
      'Kaltrina Fejzullahu',
      'Aida Mazreku',
      'Dhurata Mehmeti',
      'Leutrim Alushi',
      'Nderim Bunjaku',
      'Armend Tushaj',
      'Idriz Shahu',
      'Muhamet Cocaj',
      'Nehat Jupaj',
      'Eldin Sylejmani',
      'Agnese Halili',
      'Alban Zeneli',
      'Rrustem  Spahiu',
      'Valdrina Emini',
      'Muarem Asllani',
      'Amir Dzikezi',
      'Bekim  Syla',
      'Liridon Sadiku',
      'Eris Behluli',
      'Ilir Kosumi',
      'Blerina Zenuni',
      'Demush Ramadani Fazliu',
      'Belinda Haxhiu',
      'Fitim Zenuni',
      'Edonisa Morina',
      'Shaban  Durmishaj ',
      'Festa Mazreku',
      'Merybe Rizanaj',
      'Arife Sinani',
      'Yll Hasani',
      'Teuta Begaj ',
      'Egzona Loshi',
      'Artan Zeneli',
      'Visar Lipovica ',
      'Arlind Dema',
      'Herolind Hasimi',
      'Arburim Latifi',
      'Rinor Gjonbalaj',
      'Oltion  Rrecaj',
      'Arlinda Igrishta',
      'Rijon Tahiraj',
      'Redon Tahiraj',
      'Rina Gashi',
      'Fatos Nuli',
      'Amera Krasniqi',
      'Besian BytyÃ§i',
      'Endrit Bajraktari',
      'Edip  Rakipi',
      'Eda  Vitia ',
      'Diellona  Rexhepi ',
      'Donat Hasani',
      'Xhylije Elshani',
      'Kristjan Baftijaj',
      'Gentiana  Jashari Dragaj',
      'Linor Demiri',
      'Medina Cocaj',
      'Verona Januzi',
      'Dea Neziri ',
      'Rina Dervisholli',
      'Era Bunjaku ',
      'Gonetë Bogiqi Elshani ',
      'Evelin Dreher',
      'Aferdita Retkoceri',
      'Englondina Morina',
      'Hira Kazazi',
      'Virgjir Dragusha',
      'Meleke Misini',
      'Aurora Kurtishaj',
      'Endrita Kurtaj',
      'Blerina Susuri',
      'Milaim  Maliqi ',
      'Shqipdon Bytyqi',
      'Erblin Islami',
      'Shaban Slishani',
      'Leonorë Braimi ',
      'Rinor Bajgora',
      'Jehona Dragusha',
      'Verona Gashi',
      'Liridon Sezallari',
      'Nida Ramadanaj',
      'Florian Biffar',
      'Ylber Bajraktari',
      'Mentor Dubova',
      'Rabin Gashi',
      'Arita Mehmeti',
      'Gresa Neziri',
      'Zerina Zeneli',
      'Brahim  Ibrahimi',
      'Hyrie Haziri',
      'Gentrit Krasniqi',
      'Vesa Breznica',
      'Agon Maliqi',
      'Fiona Hajdari',
      'Emin Cakaj',
      'Faton Hajdari',
      'Aferdita Krasniqi',
      'Perparim Hodaj',
      'Dafina Rexha',
      'Edouard  Kolie',
      'Liridona Gashi',
      'Albios  Gashi',
      'Olza Shemsidini',
      'Gresa Nebihu',
      'Ines Buza',
      'Aid Mehmeti',
      'Arjan Melonashi',
      'Dasantil Jakaj',
      'Dreni Musli',
      'Antoneta Dreshaj',
      'Clirim Krasniqi',
      'Shkelzen  Sadikaj ',
      'Sumeja Hyseni',
      'Saranda Krasniqi',
      'Merve Haskuka',
      'Sundim Murtezi',
      'Ngadhnim Brati',
      'Elona Caka',
      'Alban Shabani',
      'Edis Isljami',
      'Bleonard Sadiku',
      'Arijan  Luzha',
      'Fatime Krasniqi',
      'Blerim Krasniqi',
      'Blendi  Luzha ',
      'Enhar  Sadulla',
      'Elhami Rexhepi',
      'Alma Hoti',
      'Unesa Krasniqi',
      'Florentina Spahiu',
      'Mirlinda Hasaj',
      'Marigona Haxhiu Ramaj',
      'Fjolla Zekaj',
      'Kastriot Haliti ',
      'Rina Marion Rama',
      'Elisa  Haliti',
      'Bledion Fetahu',
      'Gent  Hoxha',
      'Arbnore Dobra',
      'Albanë Xhema',
      'Agnesa Sherifi',
      'Alberita Jashari',
      'Eni  Popaj',
      'Meirem Namani',
      'Shpend Hasani',
      'Laureta Dodaj',
      'Mirjeta Ademi',
      'Vigan Canolli',
      'Taulant Terpeza',
      'Rinesa Pacarizi',
      'Driton Dragusha',
      'Ernita Berisha',
      'Doruntina Dula',
      'Luan Ibrahimi',
      'Astrit Jonuzi',
      'Selim Aliu',
      'Endrit Rashica',
      'Syart Begu',
      'Arbnor Dragusha',
      'Eduarta Gashi',
      'Blementa Kuqi',
      'Agon Sallahu',
      'Aurora Fejza',
      'Leonard Krasniqi',
      'Adrian  Krasniqi',
      'Atdhetare Kameri',
      'Lirim Rrukiqi',
      'Leutrim Ferizi',
      'Donikë  Xhosha',
      'Remzi Syla',
      'Endrit Haliti',
      'Valon Imeri',
      'Mustaf Sylejmani',
      'Amin Tala',
      'Leonora Rakaj',
      'Anes Rasimi',
      'Alban Bajgora',
      'Dionis Buzaku',
      'Lirim Musliu',
      'Xhavit Veliji',
      'Arlinda Osmani',
      'Taulant Krasniqi',
      'Ilir Hasani',
      'Fatbardh Mustafaj',
      'Fatmir Misini',
      'Besnik Ibishi',
      'Rinesa Cakolli',
      'Nisjeta Gjonbalaj',
      'Elona Krasniqi',
      'Fatjona Thaqi',
      'Shkelzen Gashi',
      'Dorontine Sylejmani',
      'Anisa Mala',
      'Pajtim Dervishaj',
      'Elhama Dogani',
      'Flora Salihi',
      'Erduan Aliu',
      'Vlora Izmaku',
      'Anisa Tushaj',
      'Nekibe Kryezi',
      'Majlinda Oshlani',
      'Freskim Mjeku',
      'Ergin Bilalli',
      'Redon Elshani',
      'Ardian Shala',
      'Arjona Racaj',
      'Taulant Rahimi',
      'Ekrem Guxholli',
      'Tirian Velija',
      'Besim Krasniqi ',
      'Selvije Caka',
      'Ermir Nivokazi',
      'Xhemile Sadrija',
      'Clirim Samakova',
      'Ardian Asllani',
      'Reshat Llapjani',
      'Edisona Sadrija',
      'Fitore Murati Abdullahu',
      'Arta Hoxha Karalija',
      'Fatlum Imeri',
      'Bujar Berisha',
      'Ronela Gashi',
      'Bliard Mulaku',
      'Lana Antonia Wehlen',
      'Eliza Sherifi',
      'Eris Mehmeti',
      'Rilind Rrustemi',
      'Ron Hasani',
      'Besnik Kalisi',
      'Erona   Konjufca',
      'Albin Gecaj',
      'Dafina Dani',
      'Ron Jaha',
      'Endrit Rashica',
      'Orgesa Maqastena',
      'Afan Shala',
      'Flamur Sallahi',
      'Mergim Limoni',
      'Abenore Rama',
      'Genc Bardiqi',
      'Vullnet Kabashi',
      'Semiha Receplar',
      'Kaltrina Muharemi',
      'Elona Grulaj',
      'Fatlind Sefedini',
      'Arduan Haxhija',
      'Ardit Brahimi',
      'Rona Recaj',
      'Muhamet Shabani',
      'Kaltrina Selimi',
      'Endrit Delija',
      'Majlinda Ahmetaj',
      'Enis Dardhishta',
      'Leotrim Hajrullahu',
      'Kristiana Shpendi',
      'Ahmet Hyseni',
      'Elza Sejdiu',
      'Donika Hoxha',
      'Florent Ujkani',
      'Endrit Januzi',
      'Monika Jana Duzhmani',
      'Ervina Behrami',
      'Valmira Alija',
      'Rina Lestrani',
      'Erduan Haxhija',
      'Zekerja Misini',
      'Abetare Vllasaliu',
      'Prparim  Ukzmali ',
      'Fjolla Sopaj',
      'Alketa Berisha',
      'Dorentina Krasniqi',
      'Rinor  Mustafa',
      'Blinera Pronaj',
      'Rrezon Aliu',
      'Lirim Ukzmali',
      'Arlind Lili',
      'Aurora Luta',
      'Almedina Tahiri',
      'Suada Tahiri',
      'Urim Hasani',
      'Behie Musa',
      'Endrit Hyseni',
      'Liridona Godeni',
      'Valdrin Dula',
      'Mirnela Sagdati',
      'Aferdita Rashiti',
      'Fjoralb Hasani',
      'Hayal Kika',
      'Armend Popova',
      'Lavdim Imeri',
      'Ibrahim Krasniqi',
      'Eris Ejupi',
      'Sinan Sadiku',
      'Mirjeta Zeqiri',
      'Shaban Sadiku',
      'Avni Morina',
      'Avdyl Braha',
      'Flakron Zhdrella',
      'Diellza Uka',
      'Elsan Shala',
      'Hajrullah Bojani',
      'Amor Zhubi',
      'Besim Bunjaku',
      'Beslinda Beqiri Sylejmani',
      'Albatrit Elezi',
      'Mensur Krasniqi',
      'Osman  Maliqi',
      'Arlind Isufi',
      'Erneta Sopi',
      'Ditjona Morina',
      'Era Syla',
      'Edonita Berisha',
      'Zenel Salihaj ',
      'Altina Mazreku',
      'Aron Bajrami',
      'Armir Statovci',
      'Edita Dembogaj',
      'Valon Leci',
      'Florent Kukaj',
      'Visar Surdulli',
      'Erdoan Mahmuti',
      'Rinesa Brahimi',
      'Erza  Isufi',
      'Fatjon Zatriqi',
      'Eron Kasumi',
      'Hasan Dogani',
      'Avni Lumi',
      'Viona Mulaku',
      'Fabian Asllani',
      'Helora Kastrati',
      'Donjeta Spahiu',
      'Drilon Haziri',
      'Dea Dervisholli',
      'Elmedina Zymberi',
      'Suela Tahiri',
      'Valton Januzi',
      'Ã‡lirim  Pajaziti',
      'Ardit Krasniqi',
      'Arian Haliti',
      'Rrezon Behrami',
      'Ali Selaci',
      'Endrita Imeri',
      'Vjollca Hajdini',
      'Flamur Mehmeti',
      'Arebresha Gashi',
      'Drilona Tafa',
      'Drilon Matoshi',
      'Riad Mustafa',
      'Diona Ã‡akmaku',
      'Endrit Troni',
      'Rina Berisha',
      'Viktorina Spaqi',
      'Gentian Skeraj',
      'Dion Bytyqi ',
      'Valton Januzi',
      'Kledon Paqarizi',
      'Agron Kutllovci',
      'Blona Lutani',
      'Blendi Hajdari',
      'Blerta Behrami',
      'Mergim Thaqi',
      'Viola Beqiri',
      'Besart Pllana',
      'Enes Abazi',
      'Samire Zymeri',
      'Verona Mucic',
      'Artim Shala',
      'Betim Sadiku',
      'Blerton Mustafa',
      'Elmedin Kalludra',
      'Shkelzen Peci',
      'Xhenete Mulaki',
      'Liridon Berisha ',
      'Real Iberdemaj',
      'Adrian Anthony  Maxhuni',
      'Adrian Rushiti',
      'Alketa Gashi',
      'Bislim Sheremeti',
      'Diona Halilaj',
      'Alltune Aliu',
      'Vanesa Braha',
      'Lulzim Zymeri',
      'Edita Gashi',
      'Flaka Ademi',
      'Riad Azemi',
      'Muhamet Bucolli',
      'Lora Bucolli',
      'Elvire Mustafa',
      'Rumejsa Krasniqi',
      'Arlind Zhubi',
      'Luljeta Peci',
      'Diellza Sahiti',
      'Habil Behrami',
      'Mirjete Thaci',
      'Dilan Ademi',
      'Urim Nimani',
      'Patrik Rrapi',
      'Fatlume Krasniqi',
      'Albion Berisha',
      'Besart Sejdiu',
      'Arbenit Govori',
      'Zana Miftari Latifi',
      'Donjeta  Mehmetaj',
      'Bestrim Gashi',
      'Mirdita Ramadani',
      'Edon Berisha',
      'Arlinda Qorraj',
      'Ekrem Halilaj',
      'Adrian Hysenaj',
      'Engjell Gashi',
      'Anita Dodaj',
      'Freskim Gula',
      'Omer Haziri',
      'Shpetim Krasniqi',
      'Bleron Arifi',
      'Fatlume Gashi',
      'Endrit Berbatovci',
      'Jon Demiri',
      'Arjeta Salihu',
      'Blerim Krasniqi',
      'Dion Demaj',
      'Orges Musliu',
      'Eron Mujeci',
      'Armir Ahmeti ',
      'Ardiana Delolli Sadiku',
      'Lavdie Murtezi',
      'Buletin Emini',
      'Albiona  Fazliu',
      'Donika Sopi',
      'Almir Pirraku',
      'Edon Hetemi',
      'Leonora Asani',
      'Nazlie Bekteshi',
      'Arblend Bylykbashi',
      'Argjend Zyhrani',
      'Altin Shala',
      'Fatmire Kabashi',
      'Donita Sadiku',
      'Lavdim Morina',
      'Adisa Latifi',
      'Driton Islami',
      'Aurora Jaha',
      'Driton Azemi',
      'Agon Halimaj',
      'Liridona Hasani',
      'Labinot Osmani',
      'Donjeta Murtezaj',
      'Jetnesa Jakupaj',
      'Senton Zaimi',
      'Ardit Halimi',
      'Meriton Berisha',
      'Yllka Guta',
      'Elton Pantina',
      'Edon Aruqaj',
      'Adrian Gervalla',
      'Diana Sadiku',
      'Edon Loxha',
      'Blerim Begolli',
      'Kosovare Gashi',
      'Elionë Tahiraj',
      'Refik Isufi',
      'Besart Hodaj',
      'Dafina Sfarqa',
      'Besarta Tahiri',
      'Eduard Havolli',
      'Shqipdon Azizi',
      'Donika Zeneli',
      'Emiraje Ibrahimi Bajrami',
      'Bleona Eminazeri',
      'Yllke Latifi',
      'Elmedin Mustafa',
      'Medina Veseli',
      'Ismet Koxha',
      'Jeton Ymeri',
      'Fatlinda Beqiri',
      'Fitore Hasani',
      'Diar Ahmeti',
      'Klevis Totri',
      'Mentor Hajdini',
      'Rejhan Zela',
      'Albion Jashanica',
      'Ajete Melenica',
      'Flamur Kastrati',
      'Mirsad Latifi',
      'Aulona Maleta',
      'Lorenzo Camozzato',
      'Ram Islami',
      'Leard Reka',
      'Muhamet Misini',
      'Shkendije Qerimi',
      'Eni Cela',
      'Ilir Jaho',
      'Gramoz Malaj',
      'Blinere Shala',
      'Besart Biba',
      'Rina Mirena',
      'Alfanos Mehmeti',
      'Redona Terziu',
      'Lorik Hiseni',
      'Jehona Marjakaj',
      'Juelda Fida',
      'Valentin Zuka',
      'Adelina Xhaferi',
      'Gjergj Brahimi',
      'Lejla Aliu',
      'Adelina Gashi',
      'Feime Haliti',
      'Betim Qerimi',
      'Atdhe Jakupi',
      'Edona Alija',
      'Rinor Shabani',
      'Arben Hajdini ',
      'Elidon Kameri',
      'Ermal Bytyqi',
      'Sellma Dermala',
      'Jehona Mehmeti',
      'Alaudin Islami',
      'Alban Rogaqi',
      'Elisa Maliqi',
      'Besim Derguti',
      'Amir Zoni',
      'Bleart Restelica',
      'Egzon Haliti',
      'Liridon Haxha',
      'Ilaz Ismajli',
      'Erona Zeqiri',
      'Gzim Sopjani',
      'Alma Curri',
      'Shqipe Shabani',
      'Rinor Sylejmani',
      'Alban Orlishta',
      'Bujar Berishaj',
      'Ledona Elezi',
      'Arjeta Sejdiu',
      'Azra Bislimi',
      'Kosovare Konjufca',
      'Anila Grajcevci',
      'Harun Hasangjekaj',
      'Urtrim Zekolli',
      'Rina Kadishani',
      'Deniz Terziqi',
      'Behare Arifaj',
      'Besart Malaj',
      'Mirlinda Shorra',
      'Enes Cani',
      'Diturie Veseli',
      'Arizona Mulaki',
      'Gani Krasniqi',
      'Besmir Malaj',
      'Fatime Imeri',
      'Argjira Gjyshinca',
      'Shpat Qalaj',
      'Drandofile Buzaki',
      'Ridvan Haxha',
      'Faris Vehapi',
      'Muhamed Hoti',
      'Sadik Hoti',
      'Albion Berisha',
      'Edi Arifi',
      'Entela Uka',
      'Fevzi Behrami',
      'Sonila TaÃ§o',
      'Albion Rashica',
      'Erdil Sadiku',
      'Rijad Rama',
      'Dardan Gashi',
      'Leonora Deliu',
      'Blerta Gashi',
      'Pajtesa Elezaj Bekteshi',
      'Shaban Maliqi',
      'Leundrit BytyÃ§i',
      'Fatushe Memeti',
      'Lulzim Zejnullahu',
      'Pashtrik Burrniku',
      'Amir Bajrami',
      'Diana Osmani',
      'Gramoza Bytyqi',
      'Flakzon Thaqi',
      'Anila Ahmeti',
      'Fjolla Geci',
      'Sefer Brando',
      'Liridonë Mema',
      'Muhamed Muli',
      'Arian Lohaj',
      'Arian Sadiku',
      'Marigonë Avdyli Gashi',
      'Alban Hasani',
      'Leunita Krasniqi',
      'Aurora Rexhepi',
      'Lorik Grainca',
      'Rrezarta Berisha',
      'Lejla Hajdini',
      'Enis Bajraktari',
      'Shaip Jashari',
      'Bardhok Teneqja',
      'Gazmend Ibrahimi',
      'Drilon Abedini',
      'Ismet Zeneli',
      'Musa Osmani',
      'Ardiana Maloku',
      'Aurela Krasniqi',
      'Mustafë Hajdari',
      'Leona Vari',
      'Leart Ferizi',
      'Ardian Qela',
      'Gentiana Dervishi ',
      'Artan Berisha',
      'Ganimete Asllani',
      'Alma Osmani ',
      'Dake Haziraj',
      'Rinor Rexha',
      'Gëzim Bekteshi',
      'Fatlum Azemi',
      'Rafet Hasani',
      'Fatime Ferizi',
      'Koste Mangelli',
      'Afet Guri',
      'Edonis Hajrizi',
      'Rozana Berisha',
      'Shpetim Zeqiraj',
      'Ruvejda Zoni',
      'Teuta Nuhiu',
      'Myvedete Grabanica',
      'Bajram Curri',
      'Musah Rashiti',
      'Musli Bela',
      'Vlora Dogoni',
      'Ejup Jusufi',
      'Argjenda Selani ',
      'Jon Makolli',
      'Edis Pantina',
      'Filloreta Xhafa',
      'Rrahman Gashi',
      'Azra Qunglla',
      'Yllka Haliti',
      'Florijan Terziu',
      'Gjejlane Rrukiqi',
      'Altin Krasniqi',
      'Baton Dervishaj',
      'Jehona Borovci',
      'Bekim Zekaj',
      'Arbenita Xhaferi',
      'Arian Hyseni',
      'Ardit Salihu',
      'Arian Brahimi',
      'Lendrit Xhemshiti',
      'Rinor Murati',
      'Luljeta Basholli',
      'Armend Morina',
      'Qendrim Gerguri',
      'Xhejlane Musliu',
      'Argona Kastrati-Morina',
      'Elvira Hasani',
      'Hekuran Berisha',
      'Jetmir Suka',
      'Yll Qelaj',
      'Dian Bytyqi',
      'Ilirjana Maliqi',
      'Liridon Shorra',
      'Merita Mehmeti',
      'Leutrim Jashari',
      'Alije Rrahmani Qosa',
      'Leuron Ilazi',
      'Saranda Paloja',
      'Anda Dragusha',
      'Edmond Ismajli',
      'Elvira Bushi',
      'Bleon Alimi',
      'Adi Fejza',
      'Besim Ahmeti',
      'Arta Elshani',
      'Djellza Halili',
      'Qendresa Plava',
      'Jetlire Maloku',
      'Shpetim Begu',
      'Flakon Vucetaj',
      'Artina Veseli',
      'Muharrem Krasniqi',
      'Samer Mustafa',
      'Ardian Xhemajlaj',
      'Jetese Thaqi',
      'Arsim Krasniqi',
      'Emine Musliu',
      'Edonis Bylykbashi',
      'Arbenita Krasniqi',
      'Leonard Haziri',
      'Fitore Qorraj',
      'Edon Ymeri',
      'Egzona Aliu',
      'Ferdi Kosova',
      'Aldrin Mujku',
      'Rizah Selmani',
      'Sevdije Peci',
      'Ariete Sadiku',
      'Shkelzen Idrizi',
      'Merisa Mikullovci',
      'Avni Hyseni',
      'Fidan Berbatovci',
      'Fehmi Isenov',
      'Dielleza Vllasalia',
      'Genta Gashi',
      'Altin GrajÃ§evci',
      'Arlind Bajramaj',
      'Enkelejda Bllaca',
      'Beltina Salihu',
      'Floresa Beciri',
      'Adrian Tupella',
      'Atlantina Grabanica',
      'Kimete Bytyqi',
      'Jone Qerimi',
      'Erzë Veseli',
      'Enver Sahiti',
      'Vlera Qerimi',
      'Erjola Basha',
      'Mimoza Abazi',
      'Nora Vula',
      'Zenel Osmani',
      'Besar Meholli',
      'Fadil Kelmendi',
      'Laura Haliti',
      'Dorontina Demiri',
      'Mehmet Cuni',
      'Driton Fazlija',
      'Arjeta Maleta',
      'Erdion Ademi',
      'Rozafa Maloku',
      'Blerdina Ahmeti',
      'Kenan Bunjaku',
      'Verona Blakaj',
      'Arjan Mahmuti',
      'Alban Matoshi',
      'Ermal Sadiku',
      'Eldina Misimi Abazibra',
      'Klodian Zhubi',
      'Bleond Recica',
      'Bajram Kalludra',
      'Xhavit Bajraktaraj',
      'Albion Mujaj',
      'Marigona Haziri',
      'Floriana Pllana',
      'Venera Krasniqi',
      'Shqipdona Hoxha',
      'Liridona Elezaj',
      'Alban Hoti',
      'Blerim Sinani',
      'Egzon Selmani',
      'Liridon Kelmendi',
      'Aida Hoti',
      'Leon Latifi',
      'Arbresha Mustafaj Haliti',
      'Enisa Zekiqi',
      'Lejla Bahtiri',
      'Agon Cakalli',
      'Hysen Halilaj',
      'Arber Deliaj',
      'Skender Neziraj',
      'Hysni Beka',
      'Mergim Bregaj',
      'Lorena Kongjinaj',
      'Mergim Ahmeti',
      'Erik Hasani',
      'Dion Krasniqi',
      'Arbona Abiti Cecelia',
      'Ardit Abazi',
      'Herolinde Qerimi',
      'Ekrem Smajli',
      'Aida Hyseni',
      'Ilir Ismajli',
      'Arjan Gashi',
      'Vigan Gercari',
      'Sara Cecelia',
      'Gentrit Maxhuni',
      'Shkurta Osmani Haliti',
      'Biondina Zekaj',
      'Premton Berisha',
      'Fitore Verbovci',
      'Adelina Veseli',
      'Rilind Hyseni',
      'Ilir Hoxha',
      'Endrit Kovaqi',
      'Enes Jusufi',
      'Ardian Vllasa',
      'Avdyl Kurti',
      'Elsa Ahmeti',
      'Valdet Gashi',
      'Qendresa Grabovci',
      'Arbenita Krasniqi',
      'Azem Osmani',
      'Hidajete Brahimi Cakaj',
      'Kreshnik Hajdari',
      'Edona Berlajolli',
      'Egzona Peci',
      'Teuta Gerxhaliu',
      'Mirsad Veseli',
      'Arber Syla Pinson',
      'Granit Pylla',
      'Vesa Polloshka',
      'Daorsa Krasniqi',
      'Gresa Pireva',
      'Leon Tofaj',
      'Agim Rrahmani',
      'Gentiana Manovi',
      'Jeton Mahmuti',
      'Rilind Tahiri',
      'Idriz Krasniqi',
      'Viona Sheqiri',
      'Fatjon Zahiti',
      'Durim Podrimqaku',
      'Mirlinda Shatrolli',
      'Bleona Rrustemi',
      'Rinor Kika',
      'Xhavit Hoxha',
      'Artiola Cakiqi',
      'Dea Sadiku',
      'Alice Sadiku',
      'Fesart Haxhiu',
      'Brendina Haxha',
      'Agnesa Ademi Delija',
      'Rrezarta Sadiku',
      'Vigan Hoxha',
      'Yllka Xhemajli',
      'Jeton Bahtiri',
      'Rafete Mehmeti',
      'Vehad Qorrolli',
      'Qamil Kuqi',
      'Ardita Parduzi',
      'Besfort Kuci',
      'Besfort Agushi',
      'Fidan Shabiu',
      'Ilirida Zogaj',
      'Adnan Preniqi',
      'Kadri Azemi',
      'Elona Jusufi',
      'Albulena Kita',
      'Njomza Jashari',
      'Alban Qosa',
      'Qendresa Azemaj',
      'Ruzhdi Vokshi',
      'Have Ibrahimi',
      'Afrim Abazi',
      'Leutrim Rrahmani',
      'Arjete Muhaxheri',
      'Florim Krasniqi',
      'Astrit Zakuti',
      'Ardi Hasanmetaj',
      'Flora Maqani',
      'Brenda Haziri',
      'Astrit Ibishi',
      'Halime Percuku',
      'Shkembim Lushtaku',
      'Arjeta Bajrami',
      'Naser Podvorica',
      'Egzon Ajeti',
      'Rejhane Tahiri',
      'Enian Vranja',
      'Ardina Rexha',
      'Fllanza Hyseni',
      'Ridona Gashi',
      'Majlinda Percuku',
      'Nexhmije Pjetri',
      'Shpend Gashi',
      'Jetmir Livoreka',
      'Fjolla Veseli',
      'Floreta Rexhepi',
      'Hanife Syla',
      'Haki Sadriu',
      'Kastriot Behrami',
      'Valmire Nika',
      'Enes Alushi',
      'Arianda Eminazeri',
      'Dardan Ferizi',
      'Bejtullah Hajra',
      'Syndrit Mehani',
      'Clirim Ejupi',
      'Arian Zenuni',
      'Berina Dermala',
      'Fatmir Jasarevic',
      'Iliesa Demi',
      'Enver Murina',
      'Doresa Mazreku',
      'Fisnik Baliu',
      'Jeton Feka',
      'Valon Jashari',
      'Jehona Berisha Lahu',
      'Mirlinda Berkolli',
      'Ridon Restelica',
      'Argjent Mjeku',
      'Naim Kastrati',
      'Besarta Limani',
      'Xhevrije Bislimi',
      'Ardita Abiti',
      'Arbnora Hasani',
      'Qazim Spahija',
      'Fatos Shkupolli',
      'Nikollë Spaqi',
      'Menderes Havolli',
      'Shpresa Musaj',
      'Leutrim Rrahmani',
      'Arjan Morina',
      'Bajram Xhemajli',
      'Artim Kurti',
      'Shpetime Zekolli',
      'Loreda Gjinoshi',
      'Vesa Miftari',
      'Xhilda Vitija',
      'Faruk Sylejmani',
      'Artur Musa',
      'Hikmete Bashota',
      'Irfan Alushi',
      'Muharrem Gashi',
      'Bujar Bajraktari',
      'Bedri Neziri',
      'Qendrim Behrami',
      'Arijana Kurshumliu Kavaja',
      'Albana Zeneli Ramadani',
      'Murat Shabani',
      'Leonora Bajrami',
      'Brilant Berila',
      'Besarta Dobërdoli',
      'Arjan Sejdiu',
      'Ardineta Bekteshi',
      'Florim Vila',
      'Domenika Delhysa',
      'Resmie Fazliu',
      'Edonis Sfarqa',
      'Besart Krasniqi',
      'Albert Krasniqi',
      'Emida Xhani',
      'Mydyr Istogu',
      'Halil Hasani',
      'Arlinda Kurti',
      'Bleona Sylejmani',
      'Fisnik Krasnici',
      'Besnik Osmani',
      'Dafina Dragusha',
      'Flamur Sllamniku',
      'Sokol Haskaj',
      'Valenton Sejdiu',
      'Elvira Sfarqa',
      'Afrim Hajdini',
      'Xhafer Spahiu',
      'Fatbardha Maxhuni',
      'Fatbardha Ismaili',
      'Ilir Arifi',
      'Arjan Koci',
      'Yllka Vranovci',
      'Leutrim Limani',
      'Shkurta Hoxhaj',
      'Arjanit Heta',
      'Mentor Klinaku',
      'Shpresa Gashi Dragusha',
      'Fitim Bangjuku',
      'Skofiar Bajraktari',
      'Etleva Salihi',
      'Arbenita Thaqi',
      'Besnik Kamberi',
      'Osman Saraci',
      'Valmire Shillova',
      'Refki Zeneli',
      'Ardian Rrahmani',
      'Abaz Beqiri',
      'Atdhe Hajrizaj',
      'Orgest Karpuzi',
      'Ferzi Gashi',
      'Skender Hoti',
      'Altrisa Eminazeri',
      'Fatlinda Fazliu',
      'Biondina Dema',
      'Vlora Ukshini',
      'Bledion Boshnjaku',
      'Egzona Dermaku',
      'Faton Tersteni',
      'Teuta Preniqi',
      'Nuran Emini',
      'Albana Sinani Xani',
      'Valentina Salihu',
      'Mergim Sadiku',
      'Fetije Alija',
      'Blerim Hasani',
      'Driata Cakiqi',
      'Nexhat Paci',
      'Kujtim Gashi',
      'Dardan Musa',
      'Melita Makolli',
      'Aurora Krasniqi',
      'Uke Kastrati',
      'Viktor Zeneli',
      'Isdriada Gashi',
      'Loreta Paqarizi',
      'Florent Marmullaku',
      'Arbenita Syla',
      'Adelina Namani',
      'Floriane Klinaku',
      'Lirije Metaj',
      'Xhenisa Nuha',
      'Adil Gurguska',
      'Lindon Muzlijaj',
      'Valerina Smajlaj',
      'Sadat Maliqi',
      'Ardita Hoxha',
      'Anafi Citaku',
      'Besnik Morina',
      'Medina Bajrami',
      'Liridon Gashi',
      'Ilir Rama',
      'Anisa Sylejmani',
      'Aida Kadriji',
      'Vehbi Behluli',
      'Nazim Avdiu',
      'Freskim Duraku',
      'Arsetina Karpuzi',
      'Donjete Jashari',
      'Besnik Poterqoi',
      'Fjord Zeneli',
      'Miradin Djelovic',
      'Redon Ejupi',
      'Dafina Recica',
      'Gresa Latifi',
      'Arbnor Haxholli',
      'Rifat Bytyqi',
      'Gentrit Cakaj',
      'Blerina Berisha Matoshi',
      'Marigona Ibishi',
      'Liridon Llapashtica',
      'Enis Percuk',
      'Genc Krasniqi',
      'Besart Hajdari',
      'Bashkim Syla',
      'Mirjon Halilaj',
      'Zahra Fetahu',
      'Fjollë Aliu',
      'Avni Zogaj',
      'Edmond Abazi',
      'Leard Muli',
      'Fatime Tupella',
      'Ymer Elshani',
      'Perparim Xhema',
      'Blerta Mehmetaj Gerguri',
      'Agim Paqarizi',
      'Dren Rexhepi',
      'Edona Ismajli Buzhala',
      'Blerina Berisha',
      'Arbenita Aliu',
      'Albulena Luma',
      'Shpetim Kajtazaj',
      'Marigona Preniqi',
      'Rizah Alimovic',
      'Ramadan Gashi',
      'Egzon Dervishaj',
      'Briselda Nebiu',
      'Erjon Kundja',
      'Valbona Shillova',
      'Erman Salihi',
      'Bardh Jahiri',
      'Alberita Gashi',
      'Pranvera Cecelia'
    ]
  },
  {
    id: 'rising_star_2026',
    name: 'Rising Star Award',
    description:
      'For the youngest employee who has shown outstanding progress, learning, and growth within the organization over a relatively short period.',
    enabled: false,
    boardSelectionText: BOARD_SELECTION_TEXT
  },
  {
    id: 'career_achievement_2026',
    name: 'Career Achievement Award',
    description:
      'This award honors employees who have dedicated ten years or more to the company, showing commitment and making a lasting impact.',
    enabled: false,
    boardSelectionText: BOARD_SELECTION_TEXT
  },
  {
    id: 'innovation_2026',
    name: 'Innovation Excellence Award',
    description:
      'For the employee who consistently brings new and innovative ideas to the company, contributing to the improvement of processes, products, or services.',
    enabled: false,
    boardSelectionText: BOARD_SELECTION_TEXT
  },
  {
    id: 'leadership_2026',
    name: 'Leadership Excellence Award',
    description:
      'For the employee who demonstrates exceptional leadership skills, inspires and motivates their team, and significantly contributes to the success of the department or organization.',
    enabled: true,
    isDropdown: true,
    accessToChoose: [
      '66f55461a65a7f26c0384c29',
      '5dd3f73a245dd830d3abb134',
      '68b9315c87c8c877d04d3dbd',
      '68b93328a5ebeaf085fe2f90',
      '68b9307887c8c877d04d3d13',
      '68b960091e7a3433220fc748',
      '68b92fc687c8c877d04d3cad',
      '68ba85244d3638cb4021e4f5',
      '68b6bd84f8ad56d30d78a4ea',
      '5d9ef7db6e558970c974fe12',
      '68b6e245b54aefba203ce37f',
      '68b6a39a08e3a5827154fc84',
      '68b5643593886cb0ceca3637',
      '68b020c753f7f0e0d9cbdcce',
      '68b580550fc7968758645d33',
      '623987f28fa9f4371ef746ab',
      '68b584aacf3367f92a6ff628',
      '68b5699795ac2b53a7a566ef',
      '68b5563578ef310db3cdfb52',
      '68b551d7bd5d1a26589196ca',
      '68b56e08a4f207f1660859ec',
      '68b55b61bff7827ce08882c5',
      '68b558807ed87a4cbf1c6281',
      '68b54ec77ed87a4cbf1c607d',
      '68b022c853f7f0e0d9cbde10',
      '68b5622975f109e10ef4f757',
      '68b197ad0fb86e504a4846fc',
      '616d7dd364959e3f7faf799c',
      '68ad9e900fd26cac5f01b841',
      '67e6bc3d56012d7fc7730f94',
      '67583fe69277c330ff053cf4',
      '68b0450d4adf78c6d6d4bc45',
      '68b045ac4adf78c6d6d4bca2',
      '68aed2664e3272cee950dba3',
      '68b59fb4fb2a3a13dd4da92c',
      '63f7712773303f9006733c2e',
      '68a997b5256d5c001bc63350',
      '68ac29dcf80b91f77755a8da',
      '670d1e9ac094ed2809449695',
      '68a5df08f76399c4e77efd3f',
      '68ac4951420a3d96ac419fa9',
      '68ac4706420a3d96ac419efb',
      '68a5a5a59de0001d612c422e',
      '68a57d536ae4a90d857c514e',
      '68a5a05a583934d60b8abad5',
      '5d9dabadf72a746e59a90380',
      '68a5a87b695c58c22bcc5886',
      '68a5a1a3583934d60b8abb3a',
      '68a43369907ce0b303769b6e',
      '68a33e0645ad6257fffc6dce',
      '68a43514907ce0b303769c29',
      '68a436488b8f6cba0a5a7bb8',
      '68a433f3907ce0b303769bcd',
      '689f18b30cfa17025b331f90',
      '689f41f907cd810014fa6fa8',
      '689f3f0b340e13bf1cef1fcd',
      '689dfdc6c9976abbfcd8eec7',
      '689f43d59fee90072464a786',
      '689f40229e2563d80f71fd36',
      '668bb1cd75d487b466cd7166',
      '6895b8957b41318dae276191',
      '6179a979877daa1294945ec9',
      '68946854843620be79db54f3',
      '68931938b08950b41bfded2a',
      '68936bcfde57c139351bac92',
      '68936cd60d0d0c5624b1419f',
      '5d9de287f72a746e59a903d9',
      '6894b23ad994df6abc767b32',
      '6894b94da35b5e18d6942902',
      '6891bcc839fd96c055a5ddcb',
      '689342dc49eb6b704da7f794',
      '688ccd87d22002d7163651fb',
      '689216490483550014165429',
      '688b6e07777c6b0013b6cff0',
      '688c845838b9ef43ca56d7f1',
      '688ccd1e0b1cd0add08c855b',
      '688cb9677b5afc1ecd388a29',
      '688b702831329fcea473a09b',
      '688b6c167fd583b897fc0ca6',
      '688cb8977b5afc1ecd3889df',
      '6888dd005e3d82f9c13dbc1b',
      '688a1c781729a600145909a0',
      '6888c7acedcf1580f49a1430',
      '6888cd296994670014baa85d',
      '6888e061049ce5f10c8bccac',
      '6888af009a1b1c49055281c3',
      '6888cebdbf819a0015a5561e',
      '688744a25e9529c54e4f990c',
      '68873f8d7db1fa0434ae281f',
      '688391cd71080734648c6ed3',
      '688745ac1da6e411ee33212e',
      '68873a5bb5c429d75e2a02e7',
      '68873ba97db1fa0434ae262c',
      '68873dfb7db1fa0434ae26b4',
      '6880f8f2de67d20014912ed5',
      '5d9d06c4f72a746e59a9035f',
      '6887264705e82747a9908ffb',
      '6880d84abf5904a3bd75ed81',
      '687f456c851394caa2324ca9',
      '6877bfe5a777307058e00923',
      '60210c2f2c7fcc0683733559',
      '6877a7dec2d9169e1d9d4253',
      '6853ce7442cf6ebc756d9f48',
      '68764cf161f4616d11da9b28',
      '68760b0a1d7fb5838c0cfdcc',
      '68760a61e0601cec0aee172f',
      '65dc94230b6a3439c69ef203',
      '6878e4fcba883c6f7faaf811',
      '6875153a900b23b48641cbfa',
      '6874bcdae4f289797b582576',
      '67a9f90fe9ced188f025a0c4',
      '6560c0a51f6d778b4f28673e',
      '6874c37a55a26cd5083ad579',
      '60d051b67244095cdd00d4da',
      '6407328973303f9006c821a9',
      '6874b6730526ad7db6118e1b',
      '654a0c8de655720602b58a7e',
      '686548a4dadfc4ecd1c7dbd0',
      '6694fc859ad192b81df2ad27',
      '686b8f36172f0a012b26435b',
      '5d9de044f72a746e59a903d1',
      '5f6a0b31064940248e1b90b7',
      '68654a6715c9ff5c3724804b',
      '6863a9eb9d1a08d2e24e3d1e',
      '685e865c9db22e42103a1467',
      '68639db22c7eeed8d3429fe4',
      '685a6cf80ebe6c10b1cb7364',
      '685a7dbaeb148083947e85bc',
      '64b7db3fc801a70a10f41bab',
      '64076ca273303f9006ca4de9',
      '5dd3f95a245dd830d3abb13b',
      '685aa7891a5494f6402e02ca',
      '655f4bfb1f6d778b4f2425e9',
      '685912cd4ca5abba8ae91254',
      '68590ced4ca5abba8ae9115d',
      '6853ccf750fdd684cba13d42',
      '6859168005722a1c2fc5d6e6',
      '67e4f88b666cf3c16ddd91e6',
      '5f0c160b111127558580a14a',
      '65549e61e655720602cb9fc1',
      '68525a5b623b398855754f69',
      '5d9de7fcf72a746e59a903e9',
      '67c1da09e7fb743de0f3a28d',
      '618425855bf9b25149507ee8',
      '684a7ddcaaeabbdb2b6b6651',
      '684ac510d03f00620841f5df',
      '61798f8f877daa129494389b',
      '685020dcbafba8202a775ecc',
      '684ac62de37a82cec6981301',
      '68485806001667749ce7c5ec',
      '684ab7de45e708b3d9b1ef55',
      '65dc815eaf459a8e3ec26f8f',
      '684812632a05cb9b8af3cbef',
      '685000487217cf3d0f4aab8d',
      '6846a96309999c001a21f9ed',
      '6846a049e93f2f99d47d184e',
      '6847f2ff83f5de7c2db67e11',
      '6846a5d9372645001bd6bc42',
      '68469fece93f2f99d47d1826',
      '6846a4e1996c2d067bcfff83',
      '6846aac309999c001a21fb2a',
      '6846a2ea302bca839a0c6434',
      '642aa5d840578200e465084a',
      '6847ef8283f5de7c2db67cda',
      '6846a3f909999c001a21f4b2',
      '6846a2ebcd5653001b138c61',
      '6842f7447df74fae6d96887d',
      '6847f189c383acb96144bbdc',
      '6846ac18372645001bd6c07d',
      '6846a802372645001bd6bde6',
      '6846a1eb09999c001a21f19b',
      '6846af50cd5653001b1396d7',
      '6846a6da996c2d067bd00053',
      '5f0c16df111127558580a14f',
      '683ec2d9eb912e019d3e77da',
      '675850bca04eee42a80a6a1c',
      '68219f2ac557305b766d7e0c',
      '682c79afb688474f45b48605',
      '682dc708905531cd97a0e8bb',
      '682c7b9ac050a09a8b699688',
      '682b342cd8ee30c33db042a2',
      '68273da10af8287989c42b86',
      '682352e3980ac02a1d2ca0b8',
      '682afd8a650b02aa031c4224',
      '6822ee07b9d3f6fa810aefa4',
      '681c62f49dea9ac2e0a280bb',
      '62fca4d264de1d5aafea7a24',
      '6818decb7f0fb1c3c0871337',
      '681b64383d4b6468105e730d',
      '6686aa2382f611eb8ee4033b',
      '681b6baa976debc31dbeb24f',
      '681b723c26de7824606e63d7',
      '681b6a7589d2e16d808eeff9',
      '681c5ff79dea9ac2e0a27fb7',
      '681b5c51a1ad4abf77c6d450',
      '681098fdaeb6040501398625',
      '680f925ee1c3a24591116d15',
      '680b539210b810de15382e7b',
      '680b7529a3170964b6d87a64',
      '680b87b68926117d0d85bce2',
      '680b5b1c48e959fabc345271',
      '62553b188fa9f4371e3cb909',
      '68010735a687dafd9646f530',
      '67ff666e3e267444dfaece7e',
      '67fcfc791d0bffe5ee362655',
      '67fe47ed32e2840c0c6643e3',
      '67f66a62e69625a552295dbb',
      '67f8e195e93f529480bfcf53',
      '5d9cfd23f72a746e59a9032d',
      '67f8d733d843a607a16d97e4',
      '5fc4fcbdc8019009eb6b3288',
      '67f5094822f54e08e10ab715',
      '67f645b6909831c49f57aff1',
      '5dd540ad245dd830d3abb1ab',
      '67f398776727df0ce24fa38b',
      '67f38f01c907f167a91325dc',
      '67d2ad28f09559b5b858251d',
      '67e6c3351b4172a8e7ce0d31',
      '67e6c459aa5cacf39f288155',
      '67ed0a38b8c0df7e33b9579f',
      '67ed071a1b92ee8fd7f5c1bf',
      '67e6bbdc61f7eebbeba914af',
      '67e6c4ec4dcd95c6082760f7',
      '67ed08bd1c6a6ab07a1b2d01',
      '67ee40c4c944044068a4acf5',
      '67e2cc6fca2dcd78cbc37fec',
      '67dade78b0c53d8e56c8826c',
      '67d987b5138ca7debc24bc7b',
      '67dd5fa349d91721a4ddafa6',
      '63dd16093c5b78d7450c90c3',
      '67dc0a527779f67954d29399',
      '67d7f0f853f75281f569f0b8',
      '67d44fd4344df61d9cb625c0',
      '5f4e48616f3ad206888444f2',
      '67d4509e344df61d9cb626b6',
      '67dad6bb3e0777b3e889f0cd',
      '67d810c309def3f1f4d13cee',
      '67d44fb4344df61d9cb62596',
      '67d450a0344df61d9cb626e4',
      '67dad7dc063e5ffe9341b3bd',
      '67cb07044d5650e072f9b0df',
      '63a3a8368aaa3ed8d0030219',
      '6446758101972e8c023352cb',
      '5d9ef6e06e558970c974fe0f',
      '67c5b4f4fda20e52e4cad909',
      '67c6f57f68d3d4509ff1ca0d',
      '67c198189cd2ecab87c1dead',
      '67bc9453fdaaf095dc03ef89',
      '67c5aa3bd7cd23996c6f2fb6',
      '67c5abeafda20e52e4cad761',
      '67c1bdbbaf16673a21bcfce1',
      '67c5b3f7fda20e52e4cad8c7',
      '67c6bfbcd5743e1bf2fcab4e',
      '67c6f40f4e0cfa47e022b3a8',
      '67af55217ff79f3d6409014e',
      '67b5ad99bc2f18bc70a7c85c',
      '64bf7b7cc801a70a10032eb0',
      '67ac73c8d682b18ed5d101a1',
      '67ac5d8cbba966a7e5d499d4',
      '670ceef493633e8f965d52cc',
      '67a9fc7ee43f6030cc5e6d58',
      '5d9cf4f9f72a746e59a90308',
      '67a47c0d5873305ccde77f04',
      '67a4be8a780153a517a5f4af',
      '67a4ce6d32a400827fe7eb17',
      '67a4d5f84062a45fe0da6ecb',
      '67a496aba7834d560a8a7f2b',
      '67a4804d4c0b09001bc90ffe',
      '67a4bc651e21d94e5c4b7d5e',
      '67a9e4557b16910014c63088',
      '67a237e48efa884c25a14037',
      '67a09530a09acc1c02f8a922',
      '67a228cad69af5616340c38d',
      '67a09666a0ea0f07a3015b9b',
      '679b893111e3ff0013a930ca',
      '67a090d0bf01b3f324f701ec',
      '6798f4041b16fe11309227d3',
      '67989d0405970c7c169daf20',
      '67989707022642983f88d110',
      '6798842687ec6bc0e4ba5699',
      '6798a2f0c7c7b80019961fd6',
      '67975f9e84876b4ee0c9f42a',
      '67a0b4b668a1a92e4f7892ca',
      '6797afcb32d8678cee1632f8',
      '678fc35f37b8147c50c2e29b',
      '678f634403e29c6d3f3dbc5c',
      '6790c70cb3a7e8022e13c6ca',
      '678e2954b53a36ef89f9b3b0',
      '638672b08aaa3ed8d0a795c5',
      '677bff0f53c860daf256046a',
      '677bb206cfa1eca981f7fed9',
      '677bc5900ff960e05f66c7fe',
      '67726cd8b3ba288783dcb5f1',
      '67766384211851001a9a3a62',
      '676e999a3950ee317e228425',
      '676a755f14d9d42b23210f3b',
      '676935a508d367d2b0d7f344',
      '67692b8ddd0062001add08e9',
      '65faf8be223cbda97a01759a',
      '675fec7dd12d1978e4892f61',
      '675ff3de2a713e06bc4ec91b',
      '675ff4e82a713e06bc4ed10c',
      '675ff15787eb897c3349d478',
      '675aa4de27e6a1d575a7fa53',
      '63f48f2d73303f90066667ca',
      '67584bdfa04eee42a80a6916',
      '675852578cdb1741b45fe43d',
      '675843889277c330ff053d4b',
      '6756b70a5ecac5c05995f192',
      '6756b3df637684ed6a2a18b7',
      '6756b30b637684ed6a2a1861',
      '63a9575f8aaa3ed8d0123414',
      '5f58ccf468f6320dd75ff1f0',
      '674d94e24f00f8bee3d2058f',
      '674595f8f9df3518caa83d06',
      '6746f1e83df3e68f97448f95',
      '67459123f9df3518caa83c6e',
      '5d9d0690f72a746e59a9035e',
      '674454f561835f50fd11ec85',
      '6744412eac027ab5e5a81ffa',
      '674443f6ac027ab5e5a820af',
      '673ee71c7eed389dcdcaefd0',
      '673f5a722d9b477c36edd395',
      '673f5c0498835c5cd3ce44f6',
      '673d97094d104617a6a421da',
      '673b0964ec04d68745787fd3',
      '673dd25657368a77a9da2b24',
      '641aba8340578200e424dd0c',
      '6731d2bcf029b767ed3a8e32',
      '67321f0cf39fd44f4cf94ed7',
      '6731c533976a623e86aebc2b',
      '5e188d9e57dec554ee11ecd3',
      '672a0f6cf6686854c24ccf60',
      '6728ce9fa0cc20fde4f008eb',
      '6728c2cdcac174be166fa5e1',
      '672890d8fd317005a89c70bf',
      '6723505982a4c16ef379b2a7',
      '672203b41ac98f4719d4fe76',
      '671f5b23e10ddc1bee8ba283',
      '671f86992dc98732bdb8a1f8',
      '671f91957c662c2765e6eaad',
      '671b82fc2053843b6d2432b0',
      '6718ee193bf2b6a16449226f',
      '648c5977d1b38e7ebe713bcd',
      '6716446cc26ed38129e13284',
      '67165b3cfd317005a8652e8c',
      '67179abfe5154bcb0a5ef54f',
      '670fa147207e5ae66dea5eb0',
      '670d1da1989f78cc704c36ce',
      '670d0fedfe8fedbe82e3a84f',
      '63b7e1518aaa3ed8d04e0ac6',
      '670d19336e8c9232226d0430',
      '670d0b9cf18a9aae73591ab7',
      '6708f57d602b30988245f8f3',
      '67053eebdea77a5429072e70',
      '670523ea8732b28ca08c7a1b',
      '6704f4b268c48c6046d3d877',
      '6707ce0c0a0606b6c7bd9090',
      '67063058023745458fff7512',
      '670550f2d63a7a46c3a9dce9',
      '6537cd15cc4eaf7f9533a25f',
      '66fd0d77a46db7b1dfbae18f',
      '67039e9e70187c845bfad964',
      '6703994e70187c845bfad7ec',
      '66fd022a2d7add7525d47c5b',
      '66fc06f234c5994592a0a20b',
      '66fd06e32d7add7525d47dc8',
      '66fbd8788a780759d1b095c6',
      '66fc02723aba8a6162a9354d',
      '66fce71349ff020b455e5a1d',
      '66faae9474b06f0d21b698df',
      '66fbfc3b534a447d357dc79d',
      '66fa6e8468c48c6046a3662a',
      '66fba0fdb436e369e4209a27',
      '66fba33829a01c39df192f56',
      '66fba3bdea50109bcff843a7',
      '66f514622e3ce77c3d457db3',
      '66f536b0aea701d40f371586',
      '66f53bfc548520e04235081d',
      '66e93154970d31989491ffdf',
      '66e7f06c3c287978b6f30278',
      '66e92f88970d31989491ff98',
      '66dee2d1753b23a5a65e4ade',
      '66dede725e5f9f8584cff910',
      '66dee6eb0af9e2565e61f568',
      '66e17fe8c272caff8f9065c5',
      '66def6e3245a4b49b6da17e1',
      '66d9befae9767286c16daa3f',
      '66d97c95dc9042c6a34a4ea9',
      '646b33bb27e0949da90eb1b7',
      '66d58860208fa23f286a379b',
      '66e03943c5cc77f3201e28dd',
      '66d07e609f84e53e972eebf3',
      '66d0811b95ab05293858e3b8',
      '66cc4e7ebcaa3366bcd49db1',
      '66d5809250423a1da748b65e',
      '5d9f23706e558970c974fe6b',
      '66c6ec79598dc9dca04a1da3',
      '66c707959b1d87d28206603f',
      '60c09b51245a503dcfb3a6da',
      '6179b066877daa1294946d6b',
      '5ff322f32c7fcc0683728971',
      '66bdb08b055c0162542f2fbb',
      '66bc984e587bbd129eaaacfd',
      '5f5f583868f6320dd75ff970',
      '5d9dae81f72a746e59a90387',
      '66b08cd014540dde95c4508e',
      '66aa2d747f53bc20f9e3c9ad',
      '66a8adc1f6d3bebf53f3add0',
      '66a8a7e6474d06cc52ad53dc',
      '66a7ae56e9b2b969efe58b63',
      '66a356e0ba748f4c606393fb',
      '66a7aa31c08e999fcf463b92',
      '66b0e731c72680fca683f9ed',
      '66a79d34cbdd588f5f5c7d20',
      '66b0e4cb8f9c0c2a72796204',
      '66a209fcef65d891864f0855',
      '6697c4b1cb363c0c27bfa78a',
      '6697c7aa8984169476629606',
      '5dd53ba2245dd830d3abb19d',
      '66979309639ebb06ed354e54',
      '6698c755b65aa5f213b4a0ea',
      '63cfa4333c5b78d745dec709',
      '6694e9e22dd6a3878ba37cac',
      '6697c1cbd95d316486ab96ad',
      '668bdbb8aaa92e10726a2c88',
      '6687f54a54a45851b8f41f4f',
      '66864c7318e7f4911462a0bf',
      '668660526537051a296d85e0',
      '668500b6dc0982d1bcccc646',
      '5d9cff87f72a746e59a9033b',
      '66839fead7c5be85c24b25d0',
      '6685625b867feb3f8d32abad',
      '6682b173ae9965b53fbbe047',
      '6683af1a5596010a2849a4ea',
      '628236cd8d16b01ee48d8d59',
      '6686a5ca6f572e08617f9708',
      '667a6ec1a27ac42c3389932b',
      '66796d063ae52ca74f2543a3',
      '666fe4cf4876f122c20da809',
      '667429dce339562d51e96e46',
      '667966b33ae52ca74f2542d8',
      '6666a873634bdb28909bafe1',
      '6666ad5e5bdcb1fdbca2e13b',
      '66670596a62f5a58db6732a1',
      '665ec6bd322d21b8f0454bec',
      '66597b258ae5bd02f5baee3c',
      '664c97e7a2d66dbedff6451e',
      '66433d1b6e4d385f9c3b669f',
      '63867f288aaa3ed8d0a7a2db',
      '6645d83b1ad5320fbce2e72b',
      '66334a05f222b750ee2d44f0',
      '663347eb7b48d582a46257a0',
      '6630f684c846049d7d5ba6bf',
      '662fa54a9ee98ea41a095e22',
      '5d9f222b6e558970c974fe66',
      '662120daed96bef56919236a',
      '661ce88c147b8f217bffa48e',
      '6617b5c7d4b492afb0db3d79',
      '660bd6e88cecbc8bca22a607',
      '660d02dd2a9668084a3a7d5f',
      '660280175837e96b91f39b3f',
      '6603fbc6454cfcaa0f95a701',
      '65fc411e719ef30f76ad3ebf',
      '65fc08f8bd0fb44f5829d554',
      '65eed34567dba79dbd83c47b',
      '65faf96a71ad5471c191c166',
      '65ef219315f1a5e8fcaa5e1f',
      '65e97fc936e4dc491dad9571',
      '660138f02498b9b0710dbb15',
      '65e6ec2be4e5fe2074ae723e',
      '65f02266095dcdba2c8bd04e',
      '5dd3a39e245dd830d3abb0cc',
      '65d4b09486c730fb0c06a93c',
      '65ce2259ac4bfaa9277ab76f',
      '65cb471dac4bfaa9277293a2',
      '65cdd649ac4bfaa92778fd8f',
      '65c2412402bc6a66cda9c514',
      '6231a8258fa9f4371eeaa33c',
      '65ba5110fe48df74311dee78',
      '65ba48d7fe48df74311db05a',
      '5de8dd1040a5b4067c720570',
      '65bcabb9a56f0bf274357053',
      '65ae47fbfe48df7431fba5b7',
      '65b0fc6da7db372ca979e9f2',
      '628233ab8d16b01ee48d52cc',
      '65a643aed03cddd483c5e588',
      '61c1b44cf4c339b6a0cff7ec',
      '5d9f27196e558970c974fe79',
      '659e862d01ad7fa536fbdd18',
      '659e58763fcc940fddc8e3d4',
      '659d08ad9d4d72d0b549559a',
      '65c0a496e4bcdc1dfc0a0f3d',
      '6582d9c4fb119a1795321555',
      '6580616dfb119a179529da6d',
      '65801098fb119a17952786cd',
      '5dd554ca245dd830d3abb1cb',
      '6572dda3fb119a17950d272e',
      '65772ac9fb119a1795141d4d',
      '65815b9dbdde7d360785055b',
      '65782827fb119a179515e498',
      '65688ecf1f6d778b4f3c1e67',
      '656892951f6d778b4f3c3b0b',
      '6572f592fb119a17950def6c',
      '6565c4ac1f6d778b4f30b065',
      '638581ee8aaa3ed8d0a42a03',
      '5d9ddd13f72a746e59a903c7',
      '656453ea1f6d778b4f2b8b13',
      '6357c4eca234e62f59d2abc8',
      '65548cede655720602cb35ad',
      '6079b2bfd80dab068a7453de',
      '63d7f2033c5b78d745f82aea',
      '63f727c173303f900670a070',
      '658061f12dad0fe8dc2f757a',
      '655f86741f6d778b4f254ad6',
      '655f29631f6d778b4f2375c8',
      '655f3edb1f6d778b4f23dba4',
      '5d9cfcbff72a746e59a9032b',
      '6540d4b7a287e406d49d6cbd',
      '653a832e9161580a3f1ee78e',
      '646729d827e0949da9091a17',
      '653a857c435d0708e4849fa5',
      '653a7a78f57f47c5c19a71c0',
      '653f970fa287e406d4987a93',
      '6537bfd39161580a3f16df5a',
      '6540d2d5a287e406d49d5e47',
      '653a605be7ea49679e88dc17',
      '653fa328a287e406d498dc28',
      '653fa78fa287e406d49908a4',
      '615d783264959e3f7f830fde',
      '653668d09161580a3f1350c5',
      '653fa174b5c77d8c7f845f7e',
      '65378e949a24822cc0b0acf4',
      '6537e25ce82860ebae280895',
      '6538fe0e9161580a3f19c5ed',
      '6537e75b25d369c13c627e8c',
      '653663919161580a3f132e2c',
      '616d881764959e3f7fafd3aa',
      '652f9b7a9161580a3f076ffe',
      '6523c15f9161580a3fefd41c',
      '6536842bfb26172121526ac3',
      '6526ab5e9161580a3ff83038',
      '5d9da805f72a746e59a90379',
      '651411b09161580a3fb9dd7a',
      '6502a9199161580a3f96f96a',
      '65085db29161580a3fa0afbc',
      '650048839161580a3f915605',
      '64e5aeebc801a70a10743778',
      '64df7626c801a70a106a1d8b',
      '64d22b3ac801a70a104ba580',
      '603e0f9bd80dab068a73739b',
      '64db8fa9c801a70a105e957d',
      '64bf84e5c801a70a10038d3f',
      '64be2a1bc801a70a10fe0ce2',
      '5d9ef7306e558970c974fe10',
      '64b6ab606e6adda9b934c727',
      '64be6c86c801a70a10005cb6',
      '64b7e573c801a70a10f46688',
      '5f90342add22357fbcef623b',
      '64a7dee1c801a70a10cff6fd',
      '649d8f6ec801a70a109cdde4',
      '5e8460fca6152815d8f14a21',
      '649d73ffc801a70a109bed3b',
      '649ad7c6c801a70a10936f34',
      '649d914cc801a70a109cf1eb',
      '605afff0d80dab068a73ecfe',
      '649aeaeac801a70a1093fc9b',
      '649af9cbc801a70a10946171',
      '631757c4a234e62f5945fd7a',
      '649ae10fc801a70a1093aca4',
      '649aa6c44d7223c2790dfe63',
      '5d9df23d6e558970c974fe07',
      '649adcfbc801a70a1093934d',
      '648c4741d1b38e7ebe70d1f0',
      '649067e2d1b38e7ebe769a9b',
      '5e57e282ecd40b7d9467d1fe',
      '6489a13dd1b38e7ebe69d473',
      '5d9d00dff72a746e59a90342',
      '648c746ad1b38e7ebe71c84b',
      '648c5c7fd1b38e7ebe715316',
      '648c488ed1b38e7ebe70da30',
      '5dd3f9dc245dd830d3abb13d',
      '5d9d0018f72a746e59a9033e',
      '648d688ed1b38e7ebe72748e',
      '647860cec5943ad7c5ca5ef6',
      '5e60f8bc05dd424259bc6190',
      '646b164927e0949da90dd596',
      '646b183727e0949da90de03c',
      '646727e227e0949da9090f32',
      '645b51e427e0949da9efdace',
      '645b549f27e0949da9efed7d',
      '645b506a27e0949da9efcc40',
      '64550d7827e0949da9dda5bf',
      '61dd897e08ce61caceb8d333',
      '644656d82a099539ed3ba663',
      '64467e778422a203757415ae',
      '64467734042b1f88ade99c48',
      '6446703d01972e8c02335094',
      '644a7a6d291c954425fa38c1',
      '644a7d37291c954425fa839d',
      '644a73e0291c954425f9f111',
      '6447d75b8422a2037578904c',
      '6437e0ba597f187f3bc0d5d6',
      '6437d604597f187f3bc0a81f',
      '6437d7e3597f187f3bc0af91',
      '642aacac40578200e4653d58',
      '642aab6d40578200e46534ad',
      '642aa22540578200e464d873',
      '642a9dec40578200e464a159',
      '641d995d40578200e4326127',
      '6414895073303f9006faa2f8',
      '64148c6373303f9006facf84',
      '62a7666864de1d5aaf22ab99',
      '6409f9c773303f9006d81b11',
      '64076ef873303f9006ca5433',
      '63fe00d973303f90068ae40b',
      '6406252e73303f9006c46012',
      '63f76ef873303f900673325c',
      '63f7733b73303f9006734952',
      '63f77d1373303f9006739437',
      '63f775c673303f9006735755',
      '63f7a19073303f900674306b',
      '63f79efb73303f9006742df4',
      '63f7993f73303f90067420dc',
      '63f79bd573303f900674272d',
      '63ee204073303f90065a450a',
      '63eca6883c5b78d7454e6fba',
      '63f8d1ba73303f900677c603',
      '63dd2dd13c5b78d7450de3cc',
      '63f88e7773303f900675cd6f',
      '63f892db73303f900675e1b2',
      '63e13a013c5b78d7451d24dd',
      '63f890c273303f900675da43',
      '63e137443c5b78d7451d053c',
      '63dcde4d3c5b78d7450a793e',
      '63e12c6c3c5b78d7451c616c',
      '63d909d83c5b78d745fbe660',
      '63d3afbf3c5b78d745ee68d6',
      '63d7d9523c5b78d745f71d1f',
      '63d3bcfe3c5b78d745ee9b44',
      '63d3b5723c5b78d745ee7c21',
      '63d3bff73c5b78d745ef12da',
      '63cfb1da3c5b78d745e020b2',
      '63d3de5a3c5b78d745efc6f0',
      '63caaac922fc77900f7472d0',
      '63d3ecd63c5b78d745f01e83',
      '63c8312f22fc77900f66a152',
      '63d2e9513c5b78d745ec51ae',
      '63d2ae843c5b78d745ec170b',
      '63c82e3922fc77900f6699fb',
      '63c9647322fc77900f6a1e53',
      '63c582638aaa3ed8d07c2749',
      '63c155588aaa3ed8d0772732',
      '63b7ddd98aaa3ed8d04df7f9',
      '63b7e1308aaa3ed8d04e08ba',
      '63bfd4a28aaa3ed8d071e5f4',
      '63b7f8cb8aaa3ed8d04edda9',
      '63c9334b22fc77900f6921fd',
      '63c80fda22fc77900f6616d7',
      '5f4e40a36f3ad2068884445d',
      '63ad62238aaa3ed8d0308115',
      '63c03e668aaa3ed8d074e383',
      '63bc40d28aaa3ed8d0607068',
      '63bc3f198aaa3ed8d0606256',
      '63bc440c8aaa3ed8d0608820',
      '639c8b488aaa3ed8d0f3ff6a',
      '639c88d68aaa3ed8d0f3f51f',
      '639c87918aaa3ed8d0f3f128',
      '639c84c18aaa3ed8d0f3e34e',
      '6391b0f48aaa3ed8d0dec498',
      '63a383ff8aaa3ed8d002c1e7',
      '6388671a8aaa3ed8d0ac7def',
      '6388653c8aaa3ed8d0ac7263',
      '63861ca38aaa3ed8d0a6e975',
      '63861bac8aaa3ed8d0a6e69c',
      '63861a108aaa3ed8d0a6e309',
      '638619098aaa3ed8d0a6de29',
      '6386152e8aaa3ed8d0a6cb3f',
      '638588bf8aaa3ed8d0a42be0',
      '63868fc48aaa3ed8d0a7a7ba',
      '638522218aaa3ed8d0a41b6c',
      '638587368aaa3ed8d0a42b97',
      '5ffd762e2c7fcc068372c01f',
      '63866e008aaa3ed8d0a79030',
      '63876f858aaa3ed8d0ab29dd',
      '63858ab98aaa3ed8d0a42c29',
      '63851f4b8aaa3ed8d0a419e6',
      '638670488aaa3ed8d0a7926a',
      '638779bf8aaa3ed8d0ab6438',
      '63876ced8aaa3ed8d0ab1ddc',
      '636c12088aaa3ed8d0703f64',
      '636c1ab68aaa3ed8d070413f',
      '636a9e0d8aaa3ed8d06c6bbe',
      '636a99388aaa3ed8d06c6659',
      '6369091f8aaa3ed8d0673d66',
      '636a94f88aaa3ed8d06c5e3a',
      '636947c48aaa3ed8d0683ea8',
      '63694add8aaa3ed8d068416e',
      '637287d28aaa3ed8d07c3303',
      '6357931ca234e62f59d0fcaa',
      '634d571fa234e62f59c3ab9c',
      '6353e8e5a234e62f59cd433d',
      '6353e70fa234e62f59cd42f4',
      '6353e53ca234e62f59cd424f',
      '6356c2f1a234e62f59d0779f',
      '6356bf5da234e62f59d01fa3',
      '634422aca234e62f59b5774c',
      '633d3a46a234e62f599ca26e',
      '634ebf83a234e62f59c68073',
      '632c1b53a234e62f596c19ca',
      '632af0d5a234e62f596a40f7',
      '632ad74aa234e62f5969e31a',
      '632adcdba234e62f5969fe67',
      '632affb1a234e62f596a8865',
      '632ad32ca234e62f5969a4b9',
      '632ad90aa234e62f5969ea7e',
      '6316f363a234e62f5942a9ed',
      '6319f59ea234e62f594cde86',
      '63172e93a234e62f594492f2',
      '6319f15fa234e62f594ccb0d',
      '6303774f64de1d5aaff32507',
      '62fe09d264de1d5aafed824d',
      '62fca14564de1d5aafea6d12',
      '5d9f11046e558970c974fe34',
      '62fdfc8e64de1d5aafecf64a',
      '62fe036d64de1d5aafed138b',
      '62ecc25164de1d5aafcdc612',
      '62ed0ffd64de1d5aafd02455',
      '62eccc4c64de1d5aafce48dd',
      '62ecc0ac64de1d5aafcdb1de',
      '60c874eb245a503dcfb3ff82',
      '62e38d6e64de1d5aafaf42b2',
      '62e3810b64de1d5aafaf03b5',
      '62d92ddd64de1d5aaf9bd463',
      '62d91ed564de1d5aaf9ba500',
      '62d9242064de1d5aaf9bbce3',
      '62d925e464de1d5aaf9bc34b',
      '62d920c464de1d5aaf9babef',
      '62d9212564de1d5aaf9bacfc',
      '62d9225964de1d5aaf9bb39d',
      '62d91d4f64de1d5aaf9b9ef7',
      '62cbdcab64de1d5aaf7e3276',
      '5e57dc67ecd40b7d9467d1f5',
      '62b9a79264de1d5aaf4364ee',
      '62bea6fe64de1d5aaf4f0925',
      '62beb5cf64de1d5aaf4f6dda',
      '62b41e3764de1d5aaf39d33e',
      '62b4183764de1d5aaf39aac2',
      '62b422ce64de1d5aaf39f638',
      '62b2c7e964de1d5aaf36a580',
      '62bea5ce64de1d5aaf4ef9d4',
      '62be9c2e64de1d5aaf4ebb48',
      '5e60b41605dd424259bc60c0',
      '60fff4b11d72340851354954',
      '62a9af5064de1d5aaf270bf9',
      '62a7722264de1d5aaf22bcdc',
      '62a7008664de1d5aaf20c746',
      '628f3f8764de1d5aafd7725a',
      '628ce0f564de1d5aafd20b6f',
      '627cb6cf5d75a15c362093cd',
      '62823ae88d16b01ee48da5c6',
      '62823c658d16b01ee48dab47',
      '6282362f8d16b01ee48d8a0f',
      '628241518d16b01ee48dbee1',
      '628237fd8d16b01ee48d9700',
      '627136165d75a15c36fdc177',
      '6272922f5d75a15c3607ca80',
      '627134015d75a15c36fda452',
      '625587c58fa9f4371e3e2af6',
      '6268e12b748d3f4c64754e0c',
      '62595ef58fa9f4371e468886',
      '625940e68fa9f4371e463cb1',
      '626bac175d75a15c36ef901c',
      '62552ab58fa9f4371e3c5c5b',
      '62556bda8fa9f4371e3d9ca1',
      '625562738fa9f4371e3d736a',
      '625535538fa9f4371e3c957c',
      '625ea1a48fa9f4371e4c56a0',
      '5d9f19596e558970c974fe45',
      '6270d91a5d75a15c36f8e717',
      '62397f698fa9f4371ef72024',
      '62455ce68fa9f4371e0b9fff',
      '623ae9b08fa9f4371ef9a13b',
      '624562818fa9f4371e0bbc3a',
      '624448ef8fa9f4371e09a280',
      '623addbd8fa9f4371ef972c1',
      '623312358fa9f4371eede52b',
      '62332ace8fa9f4371eee37cf',
      '6231b84b8fa9f4371eeb1db5',
      '62305c048fa9f4371ee813cb',
      '5d9f19256e558970c974fe44',
      '62305d798fa9f4371ee81978',
      '6231e5f78fa9f4371eebd71f',
      '6231b2508fa9f4371eeafa4b',
      '6231a4d08fa9f4371eea9109',
      '6221e37c8fa9f4371ec1ab64',
      '6217575e8fa9f4371e9e2420',
      '621502de8fa9f4371e9a1418',
      '620e50198fa9f4371e8e037b',
      '621cf03c8fa9f4371eaacbd2',
      '621763d18fa9f4371e9e6383',
      '620d1b1d8fa9f4371e8bf766',
      '621cf6558fa9f4371eaaed51',
      '620640d28fa9f4371e81e5eb',
      '620641e68fa9f4371e81e94d',
      '620658038fa9f4371e824d74',
      '62063eae8fa9f4371e81dd2a',
      '5d9dec47f72a746e59a903f6',
      '6200f3758fa9f4371e72d56f',
      '6200fe0b8fa9f4371e734366',
      '6200f2a88fa9f4371e72caf8',
      '6200eb1e8fa9f4371e72801b',
      '61f28d0c08ce61caceda8279',
      '61e588a408ce61cacec4c90a',
      '616d68eb64959e3f7fae92e7',
      '61e586df08ce61cacec4c137',
      '61dd6f9b08ce61caceb85e4d',
      '61dd857508ce61caceb8bf14',
      '61e58c4308ce61cacec4d490',
      '61fceee88fa9f4371e6620d5',
      '61e57f5f08ce61cacec49f1b',
      '5dd69490245dd830d3abb209',
      '61c31b8cf4c339b6a0d3587a',
      '5de8d9c540a5b4067c72056e',
      '61d33054f4c339b6a0ee82f7',
      '61d32db3f4c339b6a0ee71c7',
      '61d5b156f4c339b6a0fad0ae',
      '61d3353ff4c339b6a0ee994c',
      '61b8b67d94091a23e1345d21',
      '61c2d735f4c339b6a0d1fd62',
      '61c32020f4c339b6a0d373da',
      '61af232be210d6f258e668ff',
      '61c193a2f4c339b6a0cf4e48',
      '61c09ecff4c339b6a0ce2a9d',
      '61c1db27f4c339b6a0d0b63b',
      '61b0a42ce210d6f258e9fa41',
      '61a0b1256ffe503e6f60145e',
      '619d3b1c6ffe503e6f56b1e3',
      '619d387d6ffe503e6f56aeeb',
      '619d2f056ffe503e6f569d71',
      '619d204e6ffe503e6f565fb9',
      '619d3e176ffe503e6f56bd3f',
      '6179ae15877daa1294946b1e',
      '6179a2dd877daa129494593d',
      '617fc8255bf9b2514920a90c',
      '618424255bf9b251495063ea',
      '6179ab80877daa1294946812',
      '617135eb64959e3f7fbd4cd3',
      '616d76ea64959e3f7faf33c2',
      '616e81cd64959e3f7fb1affa',
      '61652dfb64959e3f7f97a8e8',
      '5d9de0daf72a746e59a903d3',
      '619b97a75bf9b251499d714c',
      '61652ed464959e3f7f97a9eb',
      '61669c0564959e3f7f9d417a',
      '615da9e664959e3f7f84b34d',
      '615ecf9864959e3f7f8895b3',
      '615eba1964959e3f7f880d85',
      '61556a7364959e3f7f5398c4',
      '614dd1de64959e3f7f372c96',
      '61545bef64959e3f7f4f62d9',
      '61571d7164959e3f7f5f9859',
      '613f31c164959e3f7ff73e10',
      '612f256d8e9c892fc842cda5',
      '612c96908e9c892fc8303606',
      '612d05ba8e9c892fc837962a',
      '612e40f88e9c892fc84064ed',
      '612364b1400ae32df8f3d8e7',
      '612cf53c8e9c892fc8374624',
      '6125f525400ae32df8fe5bfd',
      '611a17a9ec463106484c734f',
      '61289bc8400ae32df80a5350',
      '611237b1ed34205c3a631a49',
      '610256790de1e543954cd43a',
      '61010a301d723408513559af',
      '60f7ce745b3ea0533f7cde40',
      '60fa6dee1d7234085135074f',
      '60f831bf5b3ea0533f7ce173',
      '60f9450a1d7234085134f702',
      '60f9493b1d7234085134f729',
      '60f924781d7234085134f59c',
      '60fa76781d723408513507a8',
      '60f91df71d7234085134f513',
      '60f1633c98c0de0878c2429c',
      '60f151fa98c0de0878c24205',
      '60ed89153e3ae27aae7d55e1',
      '60dca29694fa422ae1492fdb',
      '60dc41a1fe41b4234e599238',
      '60dc9b1194fa422ae1492fb0',
      '60dc93ab94fa422ae1492f7e',
      '60dc994b94fa422ae1492fa2',
      '60dc5c9bfe41b4234e5993b1',
      '60dc3c90fe41b4234e599207',
      '60dc9c0d94fa422ae1492fb7',
      '60c9f0a8245a503dcfb4115d',
      '60c9b354245a503dcfb40f80',
      '60cb19ce245a503dcfb41fde',
      '60d2f40b3c84da14e41cc5a0',
      '60c0c811245a503dcfb3a8b3',
      '60c08f53245a503dcfb3a67c',
      '60bf3904245a503dcfb395f7',
      '60c09d38245a503dcfb3a6e6',
      '60af69290c4c9a0bad35c5ec',
      '60af684a0c4c9a0bad35c5d2',
      '60953dac297459014aedfae7',
      '60952ad5297459014aedfa15',
      '60950d56297459014aedf924',
      '6094f7b1297459014aedf84d',
      '6095088a297459014aedf903',
      '60a8caef0c4c9a0bad3599a1',
      '60a8b8bf0c4c9a0bad35995c',
      '6094e72a297459014aedf7a3',
      '60a8d0e90c4c9a0bad3599bb',
      '606c0d3bd80dab068a7431e7',
      '606c66bed80dab068a74376a',
      '606d806cd80dab068a743a76',
      '605a0c1bd80dab068a73eb9d',
      '6059d986d80dab068a73e970',
      '6059bb38d80dab068a73e8c5',
      '60533803d80dab068a73dca3',
      '605336a6d80dab068a73dc9e',
      '604f6611d80dab068a73d04c',
      '603f9f38d80dab068a738616',
      '603e0cdfd80dab068a737376',
      '6033ae8ed80dab068a73566e',
      '6033b067d80dab068a735674',
      '602a916b746d370673ca3435',
      '602a852d746d370673ca33ee',
      '602a7b35746d370673ca33c1',
      '602d43c2d80dab068a734729',
      '60224a792c7fcc068373390b',
      '60214e1b2c7fcc0683733713',
      '6017d1c92c7fcc068372f859',
      '600fe9c12c7fcc068372e3f9',
      '5ffd7f292c7fcc068372c06c',
      '5ffd79d72c7fcc068372c029',
      '5ffdc25a2c7fcc068372c19d',
      '5ffd749d2c7fcc068372c008',
      '5ff343c92c7fcc0683728a5e',
      '5ff348cc2c7fcc0683728a8b',
      '5fce4d887e591568a710c15f',
      '5fce4c777e591568a710c155',
      '5fc609dcc8019009eb6b365f',
      '5d9cf9e2f72a746e59a9031d',
      '5fb7bc411b0f1b22e6f746e3',
      '5faa7ec71b0f1b22e6f735ea',
      '5faa824c1b0f1b22e6f735ed',
      '5fb22b0b1b0f1b22e6f73ce5',
      '5fb233fb1b0f1b22e6f73d08',
      '5f857c5a064940248e1bce15',
      '5fa00b9f5fee9323a8e538ef',
      '5f7ad3c3064940248e1bb891',
      '5f9a933b5fee9323a8e52c68',
      '5f9a95675fee9323a8e52c7a',
      '5f4e57806f3ad20688844612',
      '5f3b84ef6f3ad206888429ca',
      '5f3a3f526f3ad2068884275c',
      '5f1e8ea1608dae18f202c558',
      '5dd4ff1c245dd830d3abb157',
      '5f155b3fe260af740ec2081f',
      '5f155bd5e260af740ec20824',
      '5e8ae7e2d0f0823574462a61',
      '5e845d9ba6152815d8f14a19',
      '5e82fd09a6152815d8f14798',
      '5d9f2b8d6e558970c974fe89',
      '5e57eb9aecd40b7d9467d212',
      '5d9f275c6e558970c974fe7a',
      '5e57dbe7ecd40b7d9467d1f3',
      '5e5777ceecd40b7d9467d1bd',
      '5e3a95ea19de6b5a83152d51',
      '5e3a93ef19de6b5a83152d4f',
      '5e20652957dec554ee11ef56',
      '5e20644957dec554ee11ef4b',
      '5e2031fc57dec554ee11eea8',
      '5e182f2e57dec554ee11ec99',
      '5e183bcf57dec554ee11eca9',
      '5e1854ba57dec554ee11ecbd',
      '5de8d6de40a5b4067c720565',
      '5e20317a57dec554ee11ee9d',
      '5de8de2b40a5b4067c720572',
      '5ddd4bfe245dd830d3abb3b2',
      '5dd69879245dd830d3abb21b',
      '5dd6971b245dd830d3abb213',
      '5ddb968c245dd830d3abb23d',
      '5dd551e4245dd830d3abb1c5',
      '5ddb9047245dd830d3abb22e',
      '5de4c500245dd830d3abb53b',
      '5dd56055245dd830d3abb1eb',
      '5ddb8edc245dd830d3abb228',
      '5dd53df2245dd830d3abb1a5',
      '5dd3a2fd245dd830d3abb0ca',
      '5dd3f60c245dd830d3abb12f',
      '5dd3b376245dd830d3abb0e0',
      '5dd53b1b245dd830d3abb19b',
      '5ddb8d4f245dd830d3abb223',
      '5dd54128245dd830d3abb1ad',
      '5d9de9b1f72a746e59a903ee',
      '5d9f10446e558970c974fe31',
      '5d9df4c86e558970c974fe0b',
      '5d9f2d576e558970c974fe91',
      '5d9da8baf72a746e59a9037b',
      '5d9f0dd86e558970c974fe28',
      '5d9f10b66e558970c974fe33',
      '5d9f28166e558970c974fe7c',
      '5d9ddf49f72a746e59a903ce',
      '5d9cf9baf72a746e59a9031c',
      '5d9cf85cf72a746e59a90315',
      '5dd65025245dd830d3abb1fb',
      '5d9f1fb26e558970c974fe5d',
      '5d9dc984f72a746e59a90399',
      '5dd3ba2f245dd830d3abb0ef',
      '5d9dada0f72a746e59a90385',
      '5d9dde54f72a746e59a903cb',
      '5dd557dc245dd830d3abb1d0',
      '5dd55cfe245dd830d3abb1de',
      '5d9daa38f72a746e59a9037f',
      '5d9d0526f72a746e59a90356',
      '5d9cfbe8f72a746e59a90328',
      '5d9d0727f72a746e59a90361',
      '5d9f2c346e558970c974fe8c',
      '5d9d0359f72a746e59a9034e',
      '5d9d049af72a746e59a90353',
      '5e60fa5705dd424259bc6198',
      '5d9deb52f72a746e59a903f3',
      '5d9cdd0f0832df6be7e49aac',
      '5d9dd40bf72a746e59a903b0',
      '5d9f1f736e558970c974fe5c',
      '5d9de6c5f72a746e59a903e5',
      '5d9cf606f72a746e59a9030b',
      '5d9dd9a1f72a746e59a903be',
      '5d9d07b6f72a746e59a90364',
      '5d9d0628f72a746e59a9035c',
      '5d9cfb25f72a746e59a90324',
      '5d9dea28f72a746e59a903ef',
      '5d9df46a6e558970c974fe0a',
      '5d9d04fef72a746e59a90355',
      '5d9f1e556e558970c974fe57',
      '5d9f1a5c6e558970c974fe49',
      '5d9da3fef72a746e59a90370',
      '5dd39cd8245dd830d3abb0bf',
      '5d9f2b176e558970c974fe87',
      '5d9f21f06e558970c974fe65',
      '5d9dcdc3f72a746e59a903a3',
      '5d9da59cf72a746e59a90374',
      '5d9efa236e558970c974fe17',
      '5d9cfd57f72a746e59a9032e',
      '5d9f15ed6e558970c974fe39',
      '5d9f20a46e558970c974fe60',
      '5d9d05b1f72a746e59a90359',
      '5d9ef7826e558970c974fe11',
      '5d9d0282f72a746e59a9034a',
      '5d9cfad0f72a746e59a90322',
      '5d9d05d6f72a746e59a9035a',
      '5d9d0254f72a746e59a90349',
      '5d9cfe96f72a746e59a90336',
      '5d9d04d1f72a746e59a90354',
      '5d9f1e8f6e558970c974fe58',
      '5d9cfff4f72a746e59a9033d',
      '5d9dcedcf72a746e59a903a6',
      '5d9df3646e558970c974fe09',
      '5d9cfc52f72a746e59a9032a',
      '5d9f20e36e558970c974fe61',
      '5d9de707f72a746e59a903e6',
      '5d9d0109f72a746e59a90343',
      '5d9df0ac6e558970c974fe02',
      '5d9efd956e558970c974fe20',
      '5d9d045bf72a746e59a90352',
      '5d9f10016e558970c974fe30',
      '5d9d0865f72a746e59a90368',
      '5d9f229c6e558970c974fe68',
      '5d9da99bf72a746e59a9037d',
      '5d9cf7e5f72a746e59a90313',
      '5d9cff39f72a746e59a90339',
      '5d9dd338f72a746e59a903ae',
      '5d9cfde5f72a746e59a90330',
      '5d9deabdf72a746e59a903f1',
      '5d9cfa71f72a746e59a90320',
      '5d9de3b7f72a746e59a903dc',
      '5d9ddab3f72a746e59a903c1',
      '5e33ff8adfabc5332136a836',
      '5d9d058ef72a746e59a90358',
      '5d9effc56e558970c974fe25',
      '5d9ef6846e558970c974fe0e',
      '5d9dc474f72a746e59a9038e',
      '5d9f28e46e558970c974fe7f',
      '5d9f25bc6e558970c974fe74',
      '5d9d00aff72a746e59a90341',
      '5d9da686f72a746e59a90376',
      '5d9da076f72a746e59a9036a',
      '5d9f22e36e558970c974fe69'
    ],
    nominees: [
      'Altin Muli',
      'Visar Rexhepi',
      'Dafina Hamzaj',
      'Dardan  Ahmeti',
      'Jetone Surdulli',
      'Fatime Hyseni ',
      'Erlind Januzi',
      'Viktorina Spaqi',
      'Besart Pllana',
      'Erolind Bajrami',
      'Donjeta Murtezaj',
      'Endrit Arifi',
      'Teisa Haxhiu Surdulli',
      'Arjanit Krasniqi',
      'Elona Hiseni',
      'Ensar Sopi',
      'Kosovare Konjufca',
      'Eduard Bajrami',
      'Mergim Azemi',
      'Blend Mziu',
      'Endrit Rrahmani',
      'Rina Kololli Derguti',
      'Edon Loki',
      'Almir Uka',
      'Osmon Hajrullahu',
      'Petrit Heta',
      'Elvira Zekolli',
      'Festina Krasniqi',
      'Visar Gashi',
      'Nesa Grezda',
      'Kenan Bunjaku',
      'Gentrit Kadriu',
      'Endrit Selimi',
      'Albert Ahmeti',
      'Fatmir Imeri',
      'Lejla Bahtiri',
      'Alfred Mehmeti',
      'Eilona Ajvazi',
      'Liridon Krasniqi',
      'Eron Berisha',
      'Blerim Ademi',
      'Selim Shabani',
      'Egzon Musa',
      'Carole Anne Couto',
      'Milot Hajdini',
      'Kujtim Ejupi',
      'Kujtim Sylaj',
      'Arian Zena',
      'Sihana Tupella',
      'Drilon Dobra',
      'Getoar Pireva',
      'Aurora Mehmeti',
      'Fatlind Krasniqi',
      'Clirimtar Jashari',
      'Qendrim Ademi',
      'Bleona Muslija',
      'Rina Kumnova',
      'Ardian Maliqi',
      'Endrit Behrami',
      'Gentian Preniqi',
      'Valmir Ibishi',
      'Armend Shala',
      'Argjent Berisha',
      'Skender Zeka',
      'Ardian Ujkani',
      'Qendresa Sadriu',
      'Meriton Zahiti',
      'Selman Ademi',
      'Vlora Sefaj',
      'Fitim Kurti',
      'Besnik Rexhepi',
      'Valdrin Garaj',
      'Zgjim Duraku',
      'Sumea Bllacaku',
      'Albert Vokrri',
      'Leonit Haradinaj',
      'Arjan Koci',
      'Adis Ahmeti',
      'Ermal Mulaj',
      'Atdhe Hajrizaj',
      'Biondina Dema',
      'Egzona Dermaku',
      'Albana Sinani Xani',
      'Mergim Sadiku',
      'Mario Mbrice',
      'Albijan Shabanaj',
      'Flamur Llumnica',
      'Albion Muzaqi',
      'Viola Bllaca',
      'Jete Shabani',
      'Drin Shala',
      'Agim Demolli',
      'Alban Gecaj',
      'Fisnik Sinani'
    ]
  },
  {
    id: 'mentorship_2026',
    name: 'Mentorship Award',
    description:
      'For the employee who has had a significant impact through mentoring and supporting the professional development of their colleagues.',
    enabled: true,
    isDropdown: true,
    accessToChoose: [
      '68aecf4ad22609001bb54891',
      '68b00eba15ac646712b360f1',
      '68b54ebf7ed87a4cbf1c604f',
      '688b72c692472d00145506cb',
      '688c650d777c6b0013b7bb28',
      '688b7a61badfca0014037cb9',
      '6880ddf047b540131cf79826',
      '687607ac5193760014f0a378',
      '6867850397049e00132a3f35',
      '687a3517a700a0001457382b',
      '687904856a81106fe6de78c8',
      '686cc3dea85608f566d3da7b',
      '625539b38fa9f4371e3cafe7',
      '683da5c600a2b8d4266d0ff2',
      '683d56f7b41a98a28f152643',
      '6821baacf3813bda3d473379',
      '6818a8afb0b9cd001b008750',
      '6818afccb0b9cd001b00c258',
      '6818938eabf2e3001bdcf83c',
      '6818ac6b671a77001bf80e89',
      '68075179af4763001bea3eba',
      '67ebf48fd50a32090370ce53',
      '67b47dbac3cc733c687aa00c',
      '6790adcdd22ccc001aaae0a7',
      '678a5e497a71ff001a65447b',
      '6787a6898faca6001a9cf4b0',
      '6762c142dc37cb0013c3db34',
      '674d9fca3df3e68f975f5f4d',
      '6745d5993df3e68f974065e9',
      '6728e5f4c45e5005016bb213',
      '671f6282bd8090aa53844406',
      '671f81587c662c2765e6e837',
      '6710c81e584f6bf09a51e75e',
      '670d09bf6e8c9232226d01b5',
      '67050cb068c48c6046d450f3',
      '6703c2147dbdca7b8cb1d608',
      '67050a4068c48c6046d44917',
      '66fba33829a01c39df192f56',
      '66f5214094f46b6203b6ff6e',
      '66f5264aa8464c7226b2b199',
      '66f55461a65a7f26c0384c29',
      '66e80c71feaedb6672f9bfb0',
      '66e17fe8c272caff8f9065c5',
      '66d85fb5a73052fef08d2d54',
      '66c709cb554ccfb9d99d2457',
      '60c09b51245a503dcfb3a6da',
      '66b332f335b9ad28aa06d54b',
      '66acee8a35b9ad28aaf64513',
      '6697c1cbd95d316486ab96ad',
      '6683bb16ff897343c7dd79e8',
      '66433d1b6e4d385f9c3b669f',
      '663b2f6ec28d8a69398fb361',
      '6627b894435f63abaf2b9620',
      '65ef219315f1a5e8fcaa5e1f',
      '660138f02498b9b0710dbb15',
      '65e6ec2be4e5fe2074ae723e',
      '65d4a8fb86c730fb0c06a6ae',
      '65cc8c2fac4bfaa92775cee6',
      '65c61cdbac4bfaa9276b32a4',
      '65bcaa3e84d76f6ca7b94e23',
      '65a52cde1f5d7fd9131135f4',
      '621789ab8fa9f4371e9eed3f',
      '65536386e655720602c8c181',
      '655f86741f6d778b4f254ad6',
      '653faef5a287e406d49937d6',
      '653fad4ba287e406d4992c69',
      '616d881764959e3f7fafd3aa',
      '65001fdd9161580a3f907856',
      '6508153f9161580a3f9f01c2',
      '64fb2c2d9161580a3f89bef6',
      '650d59079161580a3fad214a',
      '64dccd7bc801a70a10621735',
      '64bf7686c801a70a1002fc97',
      '5f90342add22357fbcef623b',
      '5dd54f0e245dd830d3abb1c1',
      '5d9d0018f72a746e59a9033e',
      '64930c68c801a70a10818be7',
      '5dd526cc245dd830d3abb18b',
      '6454f94127e0949da9dd59f5',
      '6454ee7e27e0949da9dd2b51',
      '643915ea597f187f3bc3f9b6',
      '6437decd597f187f3bc0ccf7',
      '6414873573303f9006fa9010',
      '5fd8812552f76f30dce28d80',
      '6408aeb373303f9006d3caed',
      '63ecd9a63c5b78d745501475',
      '63fc7dc873303f90067e420e',
      '63d7e8523c5b78d745f7b51c',
      '63d3f1463c5b78d745f03ada',
      '63cabba722fc77900f74dfc7',
      '63c1783d8aaa3ed8d0784190',
      '63d786a23c5b78d745f35f84',
      '63b3f2b58aaa3ed8d03c465d',
      '63e2018a3c5b78d74521df22',
      '63a16fcd8aaa3ed8d0f9f896',
      '63a37fd98aaa3ed8d002bf00',
      '63a38d748aaa3ed8d002c543',
      '63860c858aaa3ed8d0a69a38',
      '6357a404a234e62f59d17733',
      '634e9e54a234e62f59c5e855',
      '634d6b69a234e62f59c3fd5b',
      '63468dc9a234e62f59ba1c79',
      '632c254ba234e62f596e00c6',
      '632c1a56a234e62f596c15bc',
      '632ad90aa234e62f5969ea7e',
      '633d2291a234e62f599b41ae',
      '630dc30864de1d5aaf057c49',
      '62dab02764de1d5aafa05250',
      '62e9131164de1d5aafb949f5',
      '62d9212564de1d5aaf9bacfc',
      '62babfe764de1d5aaf4579be',
      '62beb4dc64de1d5aaf4f676e',
      '5e60b41605dd424259bc60c0',
      '62a9ae8e64de1d5aaf2708df',
      '62a0609e64de1d5aaf145baf',
      '6295d7b264de1d5aafeeb223',
      '628243ea8d16b01ee48dcd83',
      '628250ca8d16b01ee48e1e43',
      '628662a264de1d5aafc783a7',
      '627137a45d75a15c36fdd7d6',
      '6262badd748d3f4c646bc110',
      '62595ef58fa9f4371e468886',
      '62694cd5748d3f4c6477e5cc',
      '624a99b08fa9f4371e15e2d5',
      '625535538fa9f4371e3c957c',
      '625ea1a48fa9f4371e4c56a0',
      '626a8652748d3f4c647ad973',
      '623d91f98fa9f4371efe40c8',
      '623ae83b8fa9f4371ef99966',
      '624443e48fa9f4371e09843b',
      '620e4e208fa9f4371e8dfbb3',
      '621cf0128fa9f4371eaac96f',
      '61efc93308ce61caced55b74',
      '61e97fc008ce61cacecd792a',
      '61e8315408ce61cacecaff15',
      '5de8d9c540a5b4067c72056e',
      '61dc06e7419b02a2d771f415',
      '61c96899f4c339b6a0de6357',
      '61cc39a9f4c339b6a0e455d1',
      '61d3353ff4c339b6a0ee994c',
      '61b9ad0794091a23e135525a',
      '61af1acfe210d6f258e649a0',
      '61a72f5343fa898b7753deab',
      '61a0fc9f6ffe503e6f61cda3',
      '619d17da6ffe503e6f563776',
      '619d170a6ffe503e6f56364b',
      '6179b3d4877daa1294947a73',
      '619d204e6ffe503e6f565fb9',
      '6179a2dd877daa129494593d',
      '6179b11f877daa1294946e33',
      '5d9f1c926e558970c974fe51',
      '61a5f86f43fa898b7751e51f',
      '614db95e64959e3f7f3621d8',
      '614dc1c564959e3f7f36ad94',
      '6151c51464959e3f7f40299b',
      '61545d4d64959e3f7f4f76e7',
      '6155f1be64959e3f7f592415',
      '614de47564959e3f7f3816d2',
      '612d0a628e9c892fc837b26c',
      '60f7ed055b3ea0533f7cdf59',
      '60f9925f1d7234085134fa69',
      '60f1876198c0de0878c2439e',
      '60f151fa98c0de0878c24205',
      '5f9a89665fee9323a8e52c42',
      '60dc41a1fe41b4234e599238',
      '60dc47c6fe41b4234e599288',
      '60f1475398c0de0878c24196',
      '60c09d38245a503dcfb3a6e6',
      '60bf51cd245a503dcfb396f4',
      '60adec230c4c9a0bad35b763',
      '60950742297459014aedf8f2',
      '60793ce2d80dab068a7451d0',
      '60793fecd80dab068a7451eb',
      '60756c31d80dab068a7447f5',
      '6059bb38d80dab068a73e8c5',
      '605b010ad80dab068a73ed03',
      '604f6772d80dab068a73d05c',
      '6046202cd80dab068a73b81c',
      '6033ae8ed80dab068a73566e',
      '6033a3aed80dab068a735618',
      '602a916b746d370673ca3435',
      '602a8ec6746d370673ca3422',
      '6017f52d2c7fcc068372f9ea',
      '5f1e8ae8608dae18f202c536',
      '5e69f27892068256b073948a',
      '5ff347c32c7fcc0683728a7e',
      '5fe1b8802c7fcc0683725e9e',
      '5d9cf9e2f72a746e59a9031d',
      '5fb4f4fd1b0f1b22e6f74226',
      '5f9bf6ec5fee9323a8e53051',
      '5fa27a4c5fee9323a8e54699',
      '5fa279a95fee9323a8e54684',
      '5f719ff1064940248e1b9808',
      '5f0576391111275585809902',
      '5f6df2b8064940248e1b9636',
      '5f155a13e260af740ec20810',
      '5ede41e12a19202137981b80',
      '5e8461e5a6152815d8f14a24',
      '5e845f20a6152815d8f14a1c',
      '5d9f2b8d6e558970c974fe89',
      '5e57e0f6ecd40b7d9467d1fc',
      '5e20694757dec554ee11ef5f',
      '5e205d8057dec554ee11ef36',
      '5e182f2e57dec554ee11ec99',
      '5de8d6de40a5b4067c720565',
      '5dd544af245dd830d3abb1b7',
      '5dd3d44a245dd830d3abb11e',
      '5dd3b376245dd830d3abb0e0',
      '5d9de9b1f72a746e59a903ee',
      '5d9f10446e558970c974fe31',
      '5d9df4c86e558970c974fe0b',
      '5d9f0dd86e558970c974fe28',
      '5d9f28166e558970c974fe7c',
      '5d9ddf49f72a746e59a903ce',
      '5d9cf9baf72a746e59a9031c',
      '5d9f1fb26e558970c974fe5d',
      '5d9ddb02f72a746e59a903c2',
      '5d9de6c5f72a746e59a903e5',
      '5d9de632f72a746e59a903e3',
      '5d9de8aff72a746e59a903eb',
      '5d9f162a6e558970c974fe3a',
      '5d9dd062f72a746e59a903a8',
      '5d9de8faf72a746e59a903ec',
      '5d9de67df72a746e59a903e4',
      '5d9da59cf72a746e59a90374',
      '5d9efa236e558970c974fe17',
      '5d9ef7826e558970c974fe11',
      '5d9d03d4f72a746e59a90350',
      '5e5fc3d905dd424259bc6046',
      '5d9dcedcf72a746e59a903a6',
      '5d9efa7e6e558970c974fe18',
      '5d9da99bf72a746e59a9037d',
      '5d9efbc86e558970c974fe1c',
      '5d9cf7b2f72a746e59a90312',
      '5d9de3b7f72a746e59a903dc',
      '5d9ef5d36e558970c974fe0c',
      '5d9cf924f72a746e59a90319',
      '5d9cfbb3f72a746e59a90327',
      '5e611bf305dd424259bc6218',
      '5d9dcaedf72a746e59a9039b',
      '5eb94e2dc8d12953708ad9f2',
      '5d9ce7590832df6be7e49aaf',
      '5d9cdbf70832df6be7e49aaa',
      '5d9f2bc16e558970c974fe8a',
      '5d9cda3b0832df6be7e49aa8',
      '5d9cde230832df6be7e49aae'
    ],
    nominees: [
      'Besnik Aliu',
      'Saranda Maliqi',
      'Driton Berisha',
      'Luan Pantina',
      'Ilir Ferizaj',
      'Arta Buxhovi',
      'Enxhell Paçarada',
      'Kujtim Tetaj',
      'Kristiana Nikolli',
      'Arijan Halimi',
      'Gëzim Osmanaj',
      'Milot Bajrami'
    ]
  }
]

export const surveyCategories2026 = nextFestivalNominationCategories
